import { jsx as r, jsxs as d, Fragment as J } from "react/jsx-runtime";
import * as me from "@radix-ui/react-popover";
import * as ee from "react";
import L, { memo as cr, forwardRef as Tt, useState as P, cloneElement as Mt, createContext as dr, useEffect as se, useContext as pr, useRef as U, useCallback as Z, useMemo as Dt, createElement as gt } from "react";
import { useWidget as A, useConfig as C, useSessions as $, useMessages as O, useWidgetRouter as H, useDocumentDir as ze, useWidgetTrigger as K, useModes as Et, useCsat as Rt, useUploadFiles as mr, useIsAwaitingBotReply as Pt, useContact as jt, WidgetProvider as hr, WidgetTriggerProvider as ur } from "@opencx/widget-react-headless";
import { X as gr, ZoomOut as wr, ZoomIn as fr, RotateCcw as xr, FileText as Ot, FileSpreadsheet as At, CircleDashedIcon as vr, XIcon as Ne, SquareXIcon as br, SquareCheckBigIcon as yr, SquareCheckIcon as kr, ShrinkIcon as Cr, Minimize2Icon as zr, MinimizeIcon as Nr, Maximize2Icon as Sr, MaximizeIcon as _r, ExpandIcon as Ir, CircleXIcon as Tr, CircleCheckBigIcon as Mr, CircleCheckIcon as Ft, CheckCheckIcon as Dr, CheckIcon as Er, ChevronLeftIcon as Rr, LoaderIcon as Pr, ArrowUpIcon as Ht, PaperclipIcon as wt, CircleDashed as jr, AlertCircle as Or, Loader2 as Ar, FileAudio2Icon as Fr, FileVideo2Icon as Hr, FileIcon as Wr, UserRoundIcon as Lr, ChevronRightIcon as $r, SendHorizontal as Br, ChevronDownIcon as Ur } from "lucide-react";
import { clsx as Yr } from "clsx";
import { twMerge as Xr } from "tailwind-merge";
import { motion as re, AnimatePresence as _ } from "framer-motion";
import { Slot as qr } from "@radix-ui/react-slot";
import { cva as Wt } from "class-variance-authority";
import Lt from "remark-gfm";
import Vr from "react-markdown";
import $t from "rehype-raw";
import { isExhaustive as F, isSupportedLanguage as Gr, getTranslation as Zr } from "@opencx/widget-core";
import * as te from "@radix-ui/react-avatar";
import Bt from "@uiw/react-iframe";
import * as ae from "@radix-ui/react-tooltip";
import ft from "tinycolor2";
import { useDropzone as Kr } from "react-dropzone";
import Qr from "react-use/lib/useAsyncFn";
import { z as fe } from "zod";
function x(e) {
  return { "data-component": e };
}
const ve = [
  {
    kind: "csv",
    label: "CSV",
    mimes: ["text/csv", "application/csv"],
    extensions: ["csv"]
  },
  {
    kind: "excel",
    label: "Excel",
    mimes: [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    extensions: ["xls", "xlsx"]
  }
], xt = Object.fromEntries(
  ve.flatMap(
    (e) => e.mimes.map((o) => [o, e.extensions.map((t) => `.${t}`)])
  )
), vt = {
  "video/mp4": [".mp4"],
  "video/webm": [".webm"],
  "video/quicktime": [".mov"]
};
function Ut({
  type: e,
  name: o
}) {
  var s, i;
  const t = ((s = o.split(".").pop()) == null ? void 0 : s.toLowerCase()) ?? "", n = ((i = e.toLowerCase().split(";")[0]) == null ? void 0 : i.trim()) ?? "";
  return ve.find((a) => t && a.extensions.includes(t)) ?? ve.find((a) => n && a.mimes.includes(n)) ?? null;
}
function p(...e) {
  return Xr(Yr(e));
}
const Q = {
  x: 2,
  y: 2
}, Y = cr(
  Tt(
    ({ children: e, className: o, scale: t = 1.02, off: n = !1 }, s) => {
      const [i, a] = P(!1), [l, c] = P({ x: 0, y: 0 });
      if (n || /translate/.test(
        e.props.className || ""
      )) return e;
      const h = (v) => {
        var R, g;
        const { clientX: z, clientY: M } = v, b = v.currentTarget.getBoundingClientRect(), S = z - (b.left + b.width / 2), I = M - (b.top + b.height / 2), E = Math.max(
          -1,
          Math.min(1, S / (b.width / 2))
        ), f = Math.max(
          -1,
          Math.min(1, I / (b.height / 2))
        ), D = E * Q.x, j = f * Q.y;
        c({ x: D, y: j }), (g = (R = e.props).onMouseMove) == null || g.call(R, v);
      }, k = () => {
        var v, z;
        a(!0), (z = (v = e.props).onMouseEnter) == null || z.call(v);
      }, w = () => {
        var v, z;
        a(!1), c({ x: 0, y: 0 }), (z = (v = e.props).onMouseLeave) == null || z.call(v);
      }, u = {
        "--wobble-x": i ? `${l.x}px` : "0px",
        "--wobble-y": i ? `${l.y}px` : "0px",
        "--scale": 1 - (t - 1)
      };
      return Mt(e, {
        ref: s,
        onMouseMove: h,
        onMouseEnter: k,
        onMouseLeave: w,
        style: {
          ...u,
          ...e.props.style
        },
        className: p(
          "translate-x-[var(--wobble-x)]",
          "translate-y-[var(--wobble-y)]",
          "hover:scale-[var(--scale)] active:hover:scale-[calc(var(--scale)-0.02)]",
          o,
          e.props.className,
          "transition-all ease-out"
        )
      });
    }
  )
);
Y.displayName = "Wobble";
const Jr = 10, eo = (e, o, t) => ({
  initial: { opacity: 0, x: -e, ...o.initial },
  animate: { opacity: 1, x: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, x: e, ...o.exit }
}), to = (e, o, t) => ({
  initial: { opacity: 0, x: e, ...o.initial },
  animate: { opacity: 1, x: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, x: -e, ...o.exit }
}), ro = (e, o, t) => ({
  initial: { opacity: 0, y: e, ...o.initial },
  animate: { opacity: 1, y: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, y: -e, ...o.exit }
}), oo = (e, o, t) => ({
  initial: { opacity: 0, y: -e, ...o.initial },
  animate: { opacity: 1, y: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, y: e, ...o.exit }
}), no = {
  right: eo,
  left: to,
  up: ro,
  down: oo
}, y = Tt(
  ({
    fadeIn: e = "down",
    distance: o = Jr,
    children: t,
    snapExit: n = !1,
    overrides: s = {},
    delay: i = 0,
    ...a
  }, l) => {
    const c = e ? no[e](o, s, i) : {};
    return n && c.exit && typeof c.exit == "object" && !Array.isArray(c.exit) && (c.exit.transition = { duration: 0 }), /* @__PURE__ */ r(re.div, { ref: l, ...a, ...c, children: t });
  }
);
y.displayName = "MotionDiv";
const so = Wt(
  p(
    "inline-flex shrink-0 items-center justify-center gap-2",
    "text-sm font-medium whitespace-nowrap",
    "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    "disabled:pointer-events-none disabled:opacity-50",
    "active:scale-95 hover:active:scale-95",
    "rounded-xl",
    "transition"
  ),
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "bg-background border",
        secondary: "bg-secondary text-secondary-foreground",
        ghost: "hover:bg-secondary",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "py-2 px-3.5 text-xs",
        /**
         * This size is useful for top level buttons that needs to sit nicely inside the iframe's border radius.
         * Having the minimum height higher than usual (the `default` variant) will make the border radius look just right.
         */
        lg: "min-h-12 px-4 rounded-[20px]",
        icon: "h-10 w-10",
        fit: "size-fit p-2",
        free: "p-2",
        selfless: "p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), N = ee.forwardRef(
  ({ className: e, variant: o = "default", size: t, asChild: n = !1, ...s }, i) => /* @__PURE__ */ r(Y, { ref: i, children: /* @__PURE__ */ r(
    n ? qr : "button",
    {
      ...x("ui_lib/btn"),
      "data-variant": o,
      className: p(so({ variant: o, size: t, className: e })),
      ...s
    }
  ) })
);
N.displayName = "Button";
const Yt = dr(null);
function ao({ children: e }) {
  const [o, t] = P(!1), [n, s] = P(null), i = (l) => {
    s(l), t(!0);
  }, a = () => {
    t(!1), setTimeout(() => {
      s(null);
    }, 200);
  };
  return /* @__PURE__ */ d(
    Yt.Provider,
    {
      value: { open: i, close: a, isOpen: o, content: n },
      children: [
        /* @__PURE__ */ r(io, {}),
        e
      ]
    }
  );
}
function he() {
  const e = pr(Yt);
  return e || (console.error("useDialoger must be used within a DialogerProvider"), {
    open: () => {
    },
    close: () => {
    },
    isOpen: !1,
    content: null
  });
}
function io() {
  const { contentIframeRef: e } = A(), { isOpen: o, content: t, close: n } = he();
  return se(() => {
    var i, a;
    const s = (l) => {
      l.key === "Escape" && n();
    };
    return (a = (i = e == null ? void 0 : e.current) == null ? void 0 : i.contentWindow) == null || a.document.addEventListener(
      "keydown",
      s
    ), () => {
      var l, c;
      return (c = (l = e == null ? void 0 : e.current) == null ? void 0 : l.contentWindow) == null ? void 0 : c.document.removeEventListener(
        "keydown",
        s
      );
    };
  }, []), /* @__PURE__ */ r(_, { mode: "wait", children: o && t && /* @__PURE__ */ r(
    y,
    {
      overrides: {
        initial: { y: 0 },
        exit: { y: 0 }
      },
      className: "fixed inset-0 z-50 bg-black/60 backdrop-blur-sm",
      tabIndex: -1,
      onClick: n,
      children: t
    },
    "dialog-content"
  ) });
}
function ue({
  children: e,
  className: o,
  withClose: t = !1
}) {
  const { close: n } = he();
  return /* @__PURE__ */ d(
    "div",
    {
      className: p(
        "fixed left-[50%] top-[50%] z-50 flex flex-col gap-4 w-full max-w-[61.8%] translate-x-[-50%] translate-y-[-50%] border bg-background p-4 rounded-3xl",
        o
      ),
      onClick: (s) => s.stopPropagation(),
      children: [
        e,
        t && /* @__PURE__ */ d(
          N,
          {
            size: "fit",
            className: "rounded-full absolute top-4 right-4 opacity-50 hover:opacity-100",
            onClick: n,
            children: [
              /* @__PURE__ */ r(gr, { className: "h-4 w-4" }),
              /* @__PURE__ */ r("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  );
}
const Se = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: p("flex flex-col gap-2 text-center pt-2", e),
    ...o
  }
);
Se.displayName = "DialogerHeader";
const _e = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: p("flex flex-col gap-2 text-center", e),
    ...o
  }
);
_e.displayName = "DialogerBody";
const Xt = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r("div", { className: p("flex flex-col gap-2", e), ...o });
Xt.displayName = "DialogerFooter";
const Ie = L.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  "p",
  {
    ref: t,
    className: p(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...o
  }
));
Ie.displayName = "DialogerTitle";
const Te = L.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  "p",
  {
    ref: t,
    className: p("text-sm text-muted-foreground", e),
    ...o
  }
));
Te.displayName = "DialogerDescription";
function ge({
  children: e,
  trigger: o
}) {
  const { open: t } = he();
  return Mt(o, {
    onClick: () => {
      var s, i;
      t(e), (i = (s = o.props).onClick) == null || i.call(s);
    }
  });
}
const bt = 1, yt = 5, le = 0.5, lo = 2.5;
function co(e, o, t, n) {
  if (!t || !n || o <= 1) return { x: 0, y: 0 };
  const s = t.getBoundingClientRect(), i = n.offsetWidth, a = n.offsetHeight, l = Math.max(0, (i * o - s.width) / (2 * o)), c = Math.max(
    0,
    (a * o - s.height) / (2 * o)
  );
  return {
    x: Math.min(l, Math.max(-l, e.x)),
    y: Math.min(c, Math.max(-c, e.y))
  };
}
function qt({
  src: e,
  alt: o
}) {
  const [t, n] = P(1), [s, i] = P({ x: 0, y: 0 }), [a, l] = P(!1), c = U({ x: 0, y: 0 }), m = U({ x: 0, y: 0 }), h = U(null), k = U(null), w = U(!1), u = (f) => Math.min(yt, Math.max(bt, f)), v = Z(() => {
    n(1), i({ x: 0, y: 0 });
  }, []), z = Z(() => {
    n((f) => u(f + le));
  }, []), M = Z(() => {
    n((f) => {
      const D = u(f - le);
      return D <= 1 && i({ x: 0, y: 0 }), D;
    });
  }, []);
  Z((f) => {
    f.preventDefault(), f.stopPropagation();
    const D = f.deltaY > 0 ? -le : le;
    n((j) => {
      const R = u(j + D);
      return R <= 1 && i({ x: 0, y: 0 }), R;
    });
  }, []);
  const b = Z(
    (f) => {
      f.preventDefault(), w.current = !1, l(!0), c.current = { x: f.clientX, y: f.clientY }, m.current = { ...s }, f.target.setPointerCapture(f.pointerId);
    },
    [s]
  ), S = Z(
    (f) => {
      if (!a) return;
      const D = f.clientX - c.current.x, j = f.clientY - c.current.y;
      if ((Math.abs(D) > 3 || Math.abs(j) > 3) && (w.current = !0), t <= 1) return;
      const R = {
        x: m.current.x + D / t,
        y: m.current.y + j / t
      };
      i(
        co(R, t, h.current, k.current)
      );
    },
    [a, t]
  ), I = Z(() => {
    const f = w.current;
    l(!1), !f && n((D) => D > 1 ? (i({ x: 0, y: 0 }), 1) : lo);
  }, []), E = t > 1;
  return /* @__PURE__ */ d(
    "div",
    {
      className: "relative size-full flex items-center justify-center select-none",
      onClick: (f) => f.stopPropagation(),
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            ref: h,
            className: p(
              "overflow-hidden max-h-full max-w-full rounded-2xl flex items-center justify-center",
              E && "size-full"
            ),
            onPointerDown: b,
            onPointerMove: S,
            onPointerUp: I,
            onPointerCancel: I,
            style: {
              cursor: a ? "grabbing" : E ? "grab" : "zoom-in",
              touchAction: "none"
            },
            children: /* @__PURE__ */ r(
              "img",
              {
                ref: k,
                src: e,
                alt: o,
                className: "block max-w-full object-contain pointer-events-none",
                draggable: !1,
                style: {
                  maxHeight: "100vh",
                  transform: `scale(${t}) translate(${s.x}px, ${s.y}px)`,
                  transformOrigin: "center center"
                  // transition: isDragging ? 'none' : 'all 0.2s ease-out',
                }
              }
            )
          }
        ),
        /* @__PURE__ */ d("div", { className: "absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-1.5 py-1 transition opacity-50 hover:opacity-100", children: [
          /* @__PURE__ */ r(xe, { onClick: M, label: "Zoom out", disabled: t <= bt, children: /* @__PURE__ */ r(wr, { className: "size-3.5" }) }),
          /* @__PURE__ */ d("span", { className: "text-white text-xs font-medium min-w-[3ch] text-center tabular-nums", children: [
            Math.round(t * 100),
            "%"
          ] }),
          /* @__PURE__ */ r(xe, { onClick: z, label: "Zoom in", disabled: t >= yt, children: /* @__PURE__ */ r(fr, { className: "size-3.5" }) }),
          E && /* @__PURE__ */ d(J, { children: [
            /* @__PURE__ */ r("div", { className: "w-px h-4 bg-white/30 mx-0.5" }),
            /* @__PURE__ */ r(xe, { onClick: v, label: "Reset zoom", children: /* @__PURE__ */ r(xr, { className: "size-3.5" }) })
          ] })
        ] })
      ]
    }
  );
}
function xe({
  onClick: e,
  label: o,
  children: t,
  disabled: n
}) {
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: e,
      "aria-label": o,
      disabled: n,
      className: "text-white/80 hover:text-white disabled:text-white/30 disabled:hover:bg-transparent p-1.5 rounded-full hover:bg-white/15 transition-colors",
      children: t
    }
  );
}
function kt({
  url: e,
  name: o,
  size: t,
  icon: n,
  label: s
}) {
  return /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r(
    "a",
    {
      href: e,
      target: "_blank",
      rel: "noopener noreferrer",
      className: p(
        "block size-fit max-w-[min(100%,16rem)] shrink-0 rounded-2xl border",
        "bg-background/80 transition-colors hover:bg-accent/60",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      ),
      children: /* @__PURE__ */ d("div", { className: "flex items-center gap-3 p-3 min-w-0", children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: p(
              "flex size-10 shrink-0 items-center justify-center rounded-xl",
              "bg-secondary text-muted-foreground"
            ),
            "aria-hidden": !0,
            children: n
          }
        ),
        /* @__PURE__ */ d("div", { className: "min-w-0 flex-1 flex flex-col gap-0.5 text-left", children: [
          /* @__PURE__ */ r(
            "span",
            {
              className: p(
                "text-xs font-medium text-foreground line-clamp-1",
                "break-words [word-break:break-word]"
                // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
              ),
              children: o
            }
          ),
          /* @__PURE__ */ d("span", { className: "text-xs text-muted-foreground tabular-nums", children: [
            (t / 1024).toFixed(2),
            " KB · ",
            s
          ] })
        ] })
      ] })
    }
  ) });
}
function Vt({ attachment: e }) {
  const { name: o, size: t, type: n, url: s } = e, i = n.startsWith("image/"), a = n.startsWith("video/"), l = n.startsWith("audio/"), c = n === "application/pdf";
  if (l)
    return /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r("div", { className: "w-full shrink-0 overflow-hidden", children: /* @__PURE__ */ d("audio", { controls: !0, className: "w-full", children: [
      /* @__PURE__ */ r("source", { src: s, type: n }),
      "Your browser does not support the audio tag."
    ] }) }) });
  if (a)
    return /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r("div", { className: "w-full border shrink-0 rounded-2xl overflow-hidden", children: /* @__PURE__ */ d("video", { controls: !0, children: [
      /* @__PURE__ */ r("source", { src: s, type: n }),
      "Your browser does not support the video tag."
    ] }) }) });
  if (i)
    return /* @__PURE__ */ r(
      ge,
      {
        trigger: /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r("div", { className: "size-fit border shrink-0 rounded-2xl overflow-hidden", children: /* @__PURE__ */ r("img", { src: s, className: "object-cover size-16", alt: o }) }) }) }),
        children: /* @__PURE__ */ r(
          ue,
          {
            className: "size-full max-w-full rounded-3xl flex items-center justify-center bg-transparent border-none gap-0",
            withClose: !0,
            children: /* @__PURE__ */ r(qt, { src: s, alt: o })
          }
        )
      }
    );
  if (c)
    return /* @__PURE__ */ r(
      kt,
      {
        url: s,
        name: o,
        size: t,
        icon: /* @__PURE__ */ r(Ot, { className: "size-5", strokeWidth: 1.75 }),
        label: "PDF"
      }
    );
  const m = Ut({ type: n, name: o });
  return m ? /* @__PURE__ */ r(
    kt,
    {
      url: s,
      name: o,
      size: t,
      icon: /* @__PURE__ */ r(At, { className: "size-5", strokeWidth: 1.75 }),
      label: m.label
    }
  ) : /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r("div", { className: "size-fit border shrink-0 rounded-2xl overflow-hidden", children: /* @__PURE__ */ d("div", { className: "flex items-end gap-2 p-2", children: [
    /* @__PURE__ */ r(
      "a",
      {
        href: s,
        target: "_blank",
        rel: "noopener noreferrer",
        className: p(
          "text-xs text-blue-500 line-clamp-2 underline hover:text-blue-600",
          "break-words [word-break:break-word]"
          // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
        ),
        children: o
      }
    ),
    /* @__PURE__ */ d("span", { className: "text-xs text-muted-foreground whitespace-nowrap", children: [
      (t / 1024).toFixed(2),
      " KB"
    ] })
  ] }) }) });
}
const Gt = L.memo(
  Vr,
  (e, o) => e.children === o.children && e.className === o.className
);
function Me({
  children: e,
  messageType: o,
  messageId: t
}) {
  const { anchorTarget: n } = C();
  return /* @__PURE__ */ r(
    Gt,
    {
      "data-type": o,
      "data-id": t,
      remarkPlugins: [Lt],
      rehypePlugins: [$t],
      components: {
        a: ({ children: s, ...i }) => /* @__PURE__ */ r("a", { target: i.target || n || "_top", ...i, children: s }),
        img: ({ src: s, alt: i, ...a }) => s ? /* @__PURE__ */ r(
          ge,
          {
            trigger: /* @__PURE__ */ r(
              "img",
              {
                src: s,
                alt: i,
                ...a,
                className: "cursor-pointer rounded-xl"
              }
            ),
            children: /* @__PURE__ */ r(
              ue,
              {
                className: "size-full max-w-full rounded-3xl flex items-center justify-center bg-transparent border-none gap-0",
                withClose: !0,
                children: /* @__PURE__ */ r(qt, { src: s, alt: i })
              }
            )
          }
        ) : /* @__PURE__ */ r("img", { src: s, alt: i, ...a })
      },
      children: e
    }
  );
}
function X() {
  const {
    widgetCtx: { org: e }
  } = A(), {
    sessionState: { session: o }
  } = $(), t = C(), {
    messagesState: { messages: n }
  } = O(), {
    routerState: { screen: s }
  } = H();
  return {
    react: L,
    org: e,
    session: o,
    config: t,
    messages: n,
    currentScreen: s
  };
}
function po({
  currentMessage: e
}) {
  var n;
  const o = X(), t = (n = o.config.customComponents) == null ? void 0 : n["message::after"];
  return t ? /* @__PURE__ */ r(t, { ...o, currentMessage: e }) : null;
}
function be(e) {
  const {
    data: o,
    id: t,
    type: n,
    attachments: s,
    isFirstInGroup: i,
    isLastInGroup: a,
    isAloneInGroup: l,
    dataComponentNames: c,
    classNames: m
  } = e;
  if (n !== "AI" && n !== "AGENT") return null;
  const { message: h, variant: k = "default" } = o;
  return /* @__PURE__ */ d(
    "div",
    {
      ...x((c == null ? void 0 : c.messageContainer) ?? "chat/agent_msg/root"),
      className: p(
        "w-5/6 flex flex-col items-start gap-1",
        m == null ? void 0 : m.messageContainer
      ),
      children: [
        s && s.length > 0 && /* @__PURE__ */ r("div", { className: "w-full gap-1 flex flex-row flex-wrap items-center justify-start", children: s == null ? void 0 : s.map((w) => /* @__PURE__ */ r(Vt, { attachment: w }, w.id)) }),
        h.length > 0 && /* @__PURE__ */ d("div", { className: "flex flex-row gap-2", children: [
          /* @__PURE__ */ r(
            "div",
            {
              ...x((c == null ? void 0 : c.message) ?? "chat/agent_msg/msg"),
              "data-first": i,
              "data-last": a,
              "data-alone": l,
              "data-variant": k,
              className: p(
                "transition-all",
                "w-fit py-3 px-4 rounded-3xl bg-secondary text-secondary-foreground",
                "leading-snug text-sm prose prose-sm prose-a:decoration-primary prose-a:underline",
                "break-words [word-break:break-word]",
                // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
                // No need to add "whitespace-pre-wrap" in the agent or bot message because it is markup and content appear on separate lines as expected
                // Adding "whitespace-pre-wrap" will result in unnecessarily huge line breaks
                k === "error" && "bg-destructive/15 text-destructive",
                // We're using the booleans directly here, not the data attributes, to make any external styling more specific than this
                i && !l && "rounded-bl-md",
                a && !l && "rounded-tl-md",
                !i && !a && !l && "rounded-l-md",
                m == null ? void 0 : m.message
              ),
              children: /* @__PURE__ */ r(Me, { messageType: n, messageId: t, children: h })
            }
          ),
          /* @__PURE__ */ r(po, { currentMessage: e })
        ] })
      ]
    }
  );
}
function mo(e) {
  return /* @__PURE__ */ r("div", { className: "w-full max-w-full overflow-auto shrink-0", children: /* @__PURE__ */ r("pre", { className: "text-xs leading-tight whitespace-pre-wrap break-word", children: JSON.stringify(e, null, 1) }) });
}
const De = ee.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  te.Root,
  {
    ref: t,
    className: p(
      "relative flex size-6 aspect-square shrink-0 overflow-hidden rounded-full bg-secondary",
      // 'border',
      e
    ),
    ...o
  }
));
De.displayName = te.Root.displayName;
const Ee = ee.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  te.Image,
  {
    ref: t,
    className: p("aspect-square h-full w-full", e),
    ...o
  }
));
Ee.displayName = te.Image.displayName;
const Re = ee.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  te.Fallback,
  {
    ref: t,
    className: p(
      "flex size-full text-xs items-center justify-center rounded-lg",
      e
    ),
    ...o
  }
));
Re.displayName = te.Fallback.displayName;
function ye({
  agent: e,
  ...o
}) {
  var t, n;
  return /* @__PURE__ */ d(De, { ...o, children: [
    /* @__PURE__ */ r(Ee, { src: (e == null ? void 0 : e.avatarUrl) || (e == null ? void 0 : e.avatar) || "", alt: "Agent Icon" }),
    (e == null ? void 0 : e.name) && /* @__PURE__ */ r(Re, { children: (n = (t = e == null ? void 0 : e.name) == null ? void 0 : t.slice(0, 1)) == null ? void 0 : n.toUpperCase() })
  ] });
}
function ho({ agent: e }) {
  return /* @__PURE__ */ r(_, { children: /* @__PURE__ */ d(
    y,
    {
      ...x("chat/bot_loading/root"),
      className: "flex flex-row items-end w-full gap-2 animate-pulse",
      children: [
        /* @__PURE__ */ r(ye, { agent: e }),
        /* @__PURE__ */ d(
          "div",
          {
            ...x("chat/bot_loading/bouncing_dots_container"),
            className: p(
              "flex items-center [&_span]:bg-secondary-foreground [&_span]:size-1 gap-1 p-2 rounded-xl bg-secondary"
              // 'border',
            ),
            children: [
              /* @__PURE__ */ r(re.span, { className: "rounded-full animate-bounce [animation-delay:-0.3s]" }),
              /* @__PURE__ */ r(re.span, { className: "rounded-full animate-bounce [animation-delay:-0.15s]" }),
              /* @__PURE__ */ r(re.span, { className: "rounded-full animate-bounce" })
            ]
          }
        )
      ]
    }
  ) });
}
const Zt = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}*{-ms-overflow-style:none;scrollbar-width:none}*::-webkit-scrollbar{display:none}*{border-color:hsl(var(--opencx-border))}.\\!container{width:100%!important}.container{width:100%}@media (min-width: 640px){.\\!container{max-width:640px!important}.container{max-width:640px}}@media (min-width: 768px){.\\!container{max-width:768px!important}.container{max-width:768px}}@media (min-width: 1024px){.\\!container{max-width:1024px!important}.container{max-width:1024px}}@media (min-width: 1280px){.\\!container{max-width:1280px!important}.container{max-width:1280px}}@media (min-width: 1536px){.\\!container{max-width:1536px!important}.container{max-width:1536px}}.prose{color:var(--tw-prose-body);max-width:65ch}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-lead);font-size:1.25em;line-height:1.6;margin-top:1.2em;margin-bottom:1.2em}.prose :where(a):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-links);text-decoration:underline;font-weight:500}.prose :where(strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-bold);font-weight:600}.prose :where(a strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal;margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em}.prose :where(ol[type=A]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=A s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=I]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=I s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type="1"]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:disc;margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{font-weight:400;color:var(--tw-prose-counters)}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-bullets)}.prose :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.25em}.prose :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){border-color:var(--tw-prose-hr);border-top-width:1px;margin-top:3em;margin-bottom:3em}.prose :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:500;font-style:italic;color:var(--tw-prose-quotes);border-inline-start-width:.25rem;border-inline-start-color:var(--tw-prose-quote-borders);quotes:"“""”""‘""’";margin-top:1.6em;margin-bottom:1.6em;padding-inline-start:1em}.prose :where(blockquote p:first-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:open-quote}.prose :where(blockquote p:last-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:close-quote}.prose :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:800;font-size:2.25em;margin-top:0;margin-bottom:.8888889em;line-height:1.1111111}.prose :where(h1 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:900;color:inherit}.prose :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:700;font-size:1.5em;margin-top:2em;margin-bottom:1em;line-height:1.3333333}.prose :where(h2 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:800;color:inherit}.prose :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;font-size:1.25em;margin-top:1.6em;margin-bottom:.6em;line-height:1.6}.prose :where(h3 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:700;color:inherit}.prose :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.5em;margin-bottom:.5em;line-height:1.5}.prose :where(h4 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:700;color:inherit}.prose :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){display:block;margin-top:2em;margin-bottom:2em}.prose :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:500;font-family:inherit;color:var(--tw-prose-kbd);box-shadow:0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%),0 3px rgb(var(--tw-prose-kbd-shadows) / 10%);font-size:.875em;border-radius:.3125rem;padding-top:.1875em;padding-inline-end:.375em;padding-bottom:.1875em;padding-inline-start:.375em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-code);font-weight:600;font-size:.875em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:"`"}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:"`"}.prose :where(a code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h1 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.875em}.prose :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.9em}.prose :where(h4 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-pre-code);background-color:var(--tw-prose-pre-bg);overflow-x:auto;font-weight:400;font-size:.875em;line-height:1.7142857;margin-top:1.7142857em;margin-bottom:1.7142857em;border-radius:.375rem;padding-top:.8571429em;padding-inline-end:1.1428571em;padding-bottom:.8571429em;padding-inline-start:1.1428571em}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:transparent;border-width:0;border-radius:0;padding:0;font-weight:inherit;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:none}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:none}.prose :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){width:100%;table-layout:auto;margin-top:2em;margin-bottom:2em;font-size:.875em;line-height:1.7142857}.prose :where(thead):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-th-borders)}.prose :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;vertical-align:bottom;padding-inline-end:.5714286em;padding-bottom:.5714286em;padding-inline-start:.5714286em}.prose :where(tbody tr):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-td-borders)}.prose :where(tbody tr:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:0}.prose :where(tbody td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:baseline}.prose :where(tfoot):not(:where([class~=not-prose],[class~=not-prose] *)){border-top-width:1px;border-top-color:var(--tw-prose-th-borders)}.prose :where(tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:top}.prose :where(th,td):not(:where([class~=not-prose],[class~=not-prose] *)){text-align:start}.prose :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-captions);font-size:.875em;line-height:1.4285714;margin-top:.8571429em}.prose{--tw-prose-body: #374151;--tw-prose-headings: #111827;--tw-prose-lead: #4b5563;--tw-prose-links: #111827;--tw-prose-bold: #111827;--tw-prose-counters: #6b7280;--tw-prose-bullets: #d1d5db;--tw-prose-hr: #e5e7eb;--tw-prose-quotes: #111827;--tw-prose-quote-borders: #e5e7eb;--tw-prose-captions: #6b7280;--tw-prose-kbd: #111827;--tw-prose-kbd-shadows: 17 24 39;--tw-prose-code: #111827;--tw-prose-pre-code: #e5e7eb;--tw-prose-pre-bg: #1f2937;--tw-prose-th-borders: #d1d5db;--tw-prose-td-borders: #e5e7eb;--tw-prose-invert-body: #d1d5db;--tw-prose-invert-headings: #fff;--tw-prose-invert-lead: #9ca3af;--tw-prose-invert-links: #fff;--tw-prose-invert-bold: #fff;--tw-prose-invert-counters: #9ca3af;--tw-prose-invert-bullets: #4b5563;--tw-prose-invert-hr: #374151;--tw-prose-invert-quotes: #f3f4f6;--tw-prose-invert-quote-borders: #374151;--tw-prose-invert-captions: #9ca3af;--tw-prose-invert-kbd: #fff;--tw-prose-invert-kbd-shadows: 255 255 255;--tw-prose-invert-code: #fff;--tw-prose-invert-pre-code: #d1d5db;--tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);--tw-prose-invert-th-borders: #4b5563;--tw-prose-invert-td-borders: #374151;font-size:1rem;line-height:1.75}.prose :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;margin-bottom:.5em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.375em}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.375em}.prose :where(.prose>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(.prose>ul>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ul>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(.prose>ol>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ol>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-inline-start:1.625em}.prose :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding-top:.5714286em;padding-inline-end:.5714286em;padding-bottom:.5714286em;padding-inline-start:.5714286em}.prose :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.prose-sm{font-size:.875rem;line-height:1.7142857}.prose-sm :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em}.prose-sm :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.2857143em;line-height:1.5555556;margin-top:.8888889em;margin-bottom:.8888889em}.prose-sm :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.3333333em;margin-bottom:1.3333333em;padding-inline-start:1.1111111em}.prose-sm :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:2.1428571em;margin-top:0;margin-bottom:.8em;line-height:1.2}.prose-sm :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.4285714em;margin-top:1.6em;margin-bottom:.8em;line-height:1.4}.prose-sm :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.2857143em;margin-top:1.5555556em;margin-bottom:.4444444em;line-height:1.5555556}.prose-sm :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.4285714em;margin-bottom:.5714286em;line-height:1.4285714}.prose-sm :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose-sm :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;border-radius:.3125rem;padding-top:.1428571em;padding-inline-end:.3571429em;padding-bottom:.1428571em;padding-inline-start:.3571429em}.prose-sm :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em}.prose-sm :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.9em}.prose-sm :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8888889em}.prose-sm :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.6666667;margin-top:1.6666667em;margin-bottom:1.6666667em;border-radius:.25rem;padding-top:.6666667em;padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em;padding-inline-start:1.5714286em}.prose-sm :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em;padding-inline-start:1.5714286em}.prose-sm :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.2857143em;margin-bottom:.2857143em}.prose-sm :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.4285714em}.prose-sm :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.4285714em}.prose-sm :where(.prose-sm>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5714286em;margin-bottom:.5714286em}.prose-sm :where(.prose-sm>ul>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(.prose-sm>ul>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.1428571em}.prose-sm :where(.prose-sm>ol>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(.prose-sm>ol>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.1428571em}.prose-sm :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5714286em;margin-bottom:.5714286em}.prose-sm :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em}.prose-sm :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.2857143em;padding-inline-start:1.5714286em}.prose-sm :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2.8571429em;margin-bottom:2.8571429em}.prose-sm :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.5}.prose-sm :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose-sm :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose-sm :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding-top:.6666667em;padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose-sm :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose-sm :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose-sm :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.3333333;margin-top:.6666667em}.prose-sm :where(.prose-sm>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(.prose-sm>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.invisible{visibility:hidden}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{top:0;right:0;bottom:0;left:0}.bottom-0{bottom:0}.bottom-3{bottom:.75rem}.end-6{inset-inline-end:1.5rem}.left-1\\/2{left:50%}.left-2{left:.5rem}.left-\\[50\\%\\]{left:50%}.right-4{right:1rem}.top-2{top:.5rem}.top-4{top:1rem}.top-6{top:1.5rem}.top-\\[50\\%\\]{top:50%}.isolate{isolation:isolate}.-z-10{z-index:-10}.z-10{z-index:10}.z-50{z-index:50}.m-2{margin:.5rem}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.mx-0\\.5{margin-left:.125rem;margin-right:.125rem}.mx-auto{margin-left:auto;margin-right:auto}.my-1{margin-top:.25rem;margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.ms-auto{margin-inline-start:auto}.mt-0\\.5{margin-top:.125rem}.mt-1{margin-top:.25rem}.mt-auto{margin-top:auto}.line-clamp-1{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.line-clamp-2{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.size-0{width:0px;height:0px}.size-10{width:2.5rem;height:2.5rem}.size-12{width:3rem;height:3rem}.size-16{width:4rem;height:4rem}.size-2{width:.5rem;height:.5rem}.size-3{width:.75rem;height:.75rem}.size-3\\.5{width:.875rem;height:.875rem}.size-4{width:1rem;height:1rem}.size-5{width:1.25rem;height:1.25rem}.size-6{width:1.5rem;height:1.5rem}.size-8{width:2rem;height:2rem}.size-fit{width:fit-content;height:fit-content}.size-full{width:100%;height:100%}.h-0{height:0px}.h-10{height:2.5rem}.h-2{height:.5rem}.h-3\\.5{height:.875rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-8{height:2rem}.h-full{height:100%}.h-px{height:1px}.max-h-16{max-height:4rem}.max-h-40{max-height:10rem}.max-h-full{max-height:100%}.min-h-12{min-height:3rem}.w-0{width:0px}.w-1\\/2{width:50%}.w-10{width:2.5rem}.w-2{width:.5rem}.w-2\\/5{width:40%}.w-3\\.5{width:.875rem}.w-3\\/5{width:60%}.w-4{width:1rem}.w-5\\/6{width:83.333333%}.w-60{width:15rem}.w-9{width:2.25rem}.w-auto{width:auto}.w-fit{width:fit-content}.w-full{width:100%}.w-px{width:1px}.min-w-0{min-width:0px}.min-w-80{min-width:20rem}.min-w-\\[3ch\\]{min-width:3ch}.min-w-\\[8rem\\]{min-width:8rem}.max-w-96{max-width:24rem}.max-w-\\[61\\.8\\%\\]{max-width:61.8%}.max-w-\\[min\\(100\\%\\,16rem\\)\\]{max-width:min(100%,16rem)}.max-w-full{max-width:100%}.max-w-xs{max-width:20rem}.flex-1{flex:1 1 0%}.shrink-0{flex-shrink:0}.-translate-x-1\\/2,.translate-x-\\[-50\\%\\]{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[var\\(--wobble-x\\)\\]{--tw-translate-x: var(--wobble-x);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[-50\\%\\]{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[var\\(--wobble-y\\)\\]{--tw-translate-y: var(--wobble-y);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}.animate-bounce{animation:bounce 1s infinite}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;user-select:none}.resize-none{resize:none}.resize{resize:both}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-0{gap:0px}.gap-0\\.5{gap:.125rem}.gap-1{gap:.25rem}.gap-1\\.5{gap:.375rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-\\[1px\\]{gap:1px}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.25rem * var(--tw-space-y-reverse))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-scroll{overflow:scroll}.scroll-smooth{scroll-behavior:smooth}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-wrap{white-space:pre-wrap}.break-words{overflow-wrap:break-word}.rounded-2xl{border-radius:1rem}.rounded-3xl{border-radius:1.5rem}.rounded-\\[20px\\]{border-radius:20px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-sm{border-radius:.125rem}.rounded-xl{border-radius:.75rem}.rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.rounded-bl-md{border-bottom-left-radius:.375rem}.rounded-br-md{border-bottom-right-radius:.375rem}.rounded-tl-md{border-top-left-radius:.375rem}.rounded-tr-md{border-top-right-radius:.375rem}.border{border-width:1px}.border-2{border-width:2px}.border-none{border-style:none}.border-transparent{border-color:transparent}.bg-\\[white\\]{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-background{background-color:hsl(var(--opencx-background))}.bg-background\\/80{background-color:hsl(var(--opencx-background) / .8)}.bg-black\\/50{background-color:#00000080}.bg-black\\/60{background-color:#0009}.bg-destructive{background-color:hsl(var(--opencx-destructive))}.bg-destructive\\/15{background-color:hsl(var(--opencx-destructive) / .15)}.bg-muted{background-color:hsl(var(--opencx-muted))}.bg-primary{background-color:hsl(var(--opencx-primary))}.bg-secondary{background-color:hsl(var(--opencx-secondary))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-white\\/30{background-color:#ffffff4d}.bg-\\[radial-gradient\\(ellipse_at_top_left\\,hsl\\(var\\(--opencx-primary\\)\\)\\,transparent\\)\\,radial-gradient\\(ellipse_at_top_right\\,hsl\\(var\\(--opencx-primary\\)\\)\\,transparent\\)\\]{background-image:radial-gradient(ellipse at top left,hsl(var(--opencx-primary)),transparent),radial-gradient(ellipse at top right,hsl(var(--opencx-primary)),transparent)}.fill-current{fill:currentColor}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.p-0{padding:0}.p-1{padding:.25rem}.p-1\\.5{padding:.375rem}.p-2{padding:.5rem}.p-3{padding:.75rem}.p-4{padding:1rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-4{padding-left:1rem;padding-right:1rem}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-12{padding-top:3rem;padding-bottom:3rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.pb-0{padding-bottom:0}.pb-2{padding-bottom:.5rem}.pb-4{padding-bottom:1rem}.pe-2{padding-inline-end:.5rem}.pe-4{padding-inline-end:1rem}.ps-2{padding-inline-start:.5rem}.ps-4{padding-inline-start:1rem}.ps-8{padding-inline-start:2rem}.pt-0{padding-top:0}.pt-1{padding-top:.25rem}.pt-2{padding-top:.5rem}.text-left{text-align:left}.text-center{text-align:center}.text-start{text-align:start}.align-middle{vertical-align:middle}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-2xl{font-size:1.5rem;line-height:2rem}.text-4xl{font-size:2.25rem;line-height:2.5rem}.text-\\[1\\.75rem\\]{font-size:1.75rem}.text-\\[10px\\]{font-size:10px}.text-\\[16px\\]{font-size:16px}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.tabular-nums{--tw-numeric-spacing: tabular-nums;font-variant-numeric:var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction)}.leading-none{line-height:1}.leading-snug{line-height:1.375}.leading-tight{line-height:1.25}.tracking-tight{letter-spacing:-.025em}.tracking-widest{letter-spacing:.1em}.text-blue-500{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.text-destructive{color:hsl(var(--opencx-destructive))}.text-destructive-foreground{color:hsl(var(--opencx-destructive-foreground))}.text-emerald-600{--tw-text-opacity: 1;color:rgb(5 150 105 / var(--tw-text-opacity, 1))}.text-foreground{color:hsl(var(--opencx-foreground))}.text-muted-foreground{color:hsl(var(--opencx-muted-foreground))}.text-muted-foreground\\/70{color:hsl(var(--opencx-muted-foreground) / .7)}.text-muted-foreground\\/75{color:hsl(var(--opencx-muted-foreground) / .75)}.text-primary{color:hsl(var(--opencx-primary))}.text-primary-foreground{color:hsl(var(--opencx-primary-foreground))}.text-secondary-foreground{color:hsl(var(--opencx-secondary-foreground))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.text-white\\/80{color:#fffc}.underline{text-decoration-line:underline}.underline-offset-4{text-underline-offset:4px}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-20{opacity:.2}.opacity-35{opacity:.35}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.opacity-95{opacity:.95}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-2xl{--tw-shadow: 0 25px 50px -12px rgb(0 0 0 / .25);--tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-8{outline-width:8px}.outline-background{outline-color:hsl(var(--opencx-background))}.ring-0{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-offset-background{--tw-ring-offset-color: hsl(var(--opencx-background))}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-\\[height\\]{transition-property:height;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.animate-in{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.fade-in-0{--tw-enter-opacity: 0}.zoom-in{--tw-enter-scale: 0}.zoom-in-95{--tw-enter-scale: .95}.ease-out{animation-timing-function:cubic-bezier(0,0,.2,1)}.\\[animation-delay\\:-0\\.15s\\]{animation-delay:-.15s}.\\[animation-delay\\:-0\\.3s\\]{animation-delay:-.3s}.\\[field-sizing\\:content\\;\\],.\\[field-sizing\\:content\\]{field-sizing:content}.\\[word-break\\:break-word\\]{word-break:break-word}.file\\:border-0::file-selector-button{border-width:0px}.file\\:bg-transparent::file-selector-button{background-color:transparent}.file\\:text-sm::file-selector-button{font-size:.875rem;line-height:1.25rem}.file\\:font-medium::file-selector-button{font-weight:500}.file\\:text-primary-foreground::file-selector-button{color:hsl(var(--opencx-primary-foreground))}.placeholder\\:text-muted-foreground::placeholder{color:hsl(var(--opencx-muted-foreground))}.placeholder\\:text-muted-foreground\\/75::placeholder{color:hsl(var(--opencx-muted-foreground) / .75)}.focus-within\\:border-primary:focus-within{border-color:hsl(var(--opencx-primary))}.hover\\:scale-\\[var\\(--scale\\)\\]:hover{--tw-scale-x: var(--scale);--tw-scale-y: var(--scale);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:border-primary:hover{border-color:hsl(var(--opencx-primary))}.hover\\:bg-accent\\/60:hover{background-color:hsl(var(--opencx-accent) / .6)}.hover\\:bg-secondary:hover{background-color:hsl(var(--opencx-secondary))}.hover\\:bg-white\\/15:hover{background-color:#ffffff26}.hover\\:text-blue-600:hover{--tw-text-opacity: 1;color:rgb(37 99 235 / var(--tw-text-opacity, 1))}.hover\\:text-primary:hover{color:hsl(var(--opencx-primary))}.hover\\:text-white:hover{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:opacity-100:hover{opacity:1}.focus\\:bg-accent:focus{background-color:hsl(var(--opencx-accent))}.focus\\:text-accent-foreground:focus{color:hsl(var(--opencx-accent-foreground))}.focus-visible\\:outline-none:focus-visible{outline:2px solid transparent;outline-offset:2px}.focus-visible\\:ring-2:focus-visible{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus-visible\\:ring-ring:focus-visible{--tw-ring-color: hsl(var(--opencx-ring))}.focus-visible\\:ring-offset-2:focus-visible{--tw-ring-offset-width: 2px}.focus-visible\\:ring-offset-background:focus-visible{--tw-ring-offset-color: hsl(var(--opencx-background))}.active\\:scale-95:active{--tw-scale-x: .95;--tw-scale-y: .95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.active\\:hover\\:scale-\\[calc\\(var\\(--scale\\)-0\\.02\\)\\]:hover:active{--tw-scale-x: calc(var(--scale) - .02);--tw-scale-y: calc(var(--scale) - .02);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:active\\:scale-95:active:hover{--tw-scale-x: .95;--tw-scale-y: .95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:text-white\\/30:disabled{color:#ffffff4d}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:hover\\:bg-transparent:hover:disabled{background-color:transparent}.group:hover .group-hover\\:opacity-100{opacity:1}.group:hover .group-hover\\:active\\:scale-90:active,.group:active .group-active\\:scale-90{--tw-scale-x: .9;--tw-scale-y: .9;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{pointer-events:none}.data-\\[state\\=checked\\]\\:translate-x-4[data-state=checked]{--tw-translate-x: 1rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state=unchecked]{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=checked\\]\\:bg-primary[data-state=checked]{background-color:hsl(var(--opencx-primary))}.data-\\[state\\=open\\]\\:bg-accent[data-state=open]{background-color:hsl(var(--opencx-accent))}.data-\\[state\\=unchecked\\]\\:bg-input[data-state=unchecked]{background-color:hsl(var(--opencx-input))}.data-\\[disabled\\]\\:opacity-50[data-disabled]{opacity:.5}.data-\\[state\\=open\\]\\:animate-in[data-state=open]{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.data-\\[state\\=closed\\]\\:animate-out[data-state=closed]{animation-name:exit;animation-duration:.15s;--tw-exit-opacity: initial;--tw-exit-scale: initial;--tw-exit-rotate: initial;--tw-exit-translate-x: initial;--tw-exit-translate-y: initial}.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed]{--tw-exit-opacity: 0}.data-\\[state\\=open\\]\\:fade-in-0[data-state=open]{--tw-enter-opacity: 0}.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed]{--tw-exit-scale: .95}.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open]{--tw-enter-scale: .95}.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom]{--tw-enter-translate-y: -.5rem}.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left]{--tw-enter-translate-x: .5rem}.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right]{--tw-enter-translate-x: -.5rem}.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top]{--tw-enter-translate-y: .5rem}.prose-a\\:underline :is(:where(a):not(:where([class~=not-prose],[class~=not-prose] *))){text-decoration-line:underline}.prose-a\\:decoration-primary :is(:where(a):not(:where([class~=not-prose],[class~=not-prose] *))){text-decoration-color:hsl(var(--opencx-primary))}.rtl\\:-scale-100:where([dir=rtl],[dir=rtl] *){--tw-scale-x: -1;--tw-scale-y: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\[\\&_span\\]\\:size-1 span{width:.25rem;height:.25rem}.\\[\\&_span\\]\\:bg-secondary-foreground span{background-color:hsl(var(--opencx-secondary-foreground))}.\\[\\&_svg\\]\\:pointer-events-none svg{pointer-events:none}.\\[\\&_svg\\]\\:size-4 svg{width:1rem;height:1rem}.\\[\\&_svg\\]\\:shrink-0 svg{flex-shrink:0}.\\[\\&_svg\\]\\:text-muted-foreground\\/70 svg{color:hsl(var(--opencx-muted-foreground) / .7)}.\\[\\&_svg\\]\\:hover\\:text-primary:hover svg{color:hsl(var(--opencx-primary))}', uo = ae.Provider, go = ae.Root, wo = ae.Trigger, Kt = ee.forwardRef(({ className: e, sideOffset: o = 4, ...t }, n) => /* @__PURE__ */ r(
  ae.Content,
  {
    ref: n,
    sideOffset: o,
    className: p(
      "z-50 overflow-hidden max-w-xs rounded-xl bg-primary border text-primary-foreground p-2 text-center align-middle text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Kt.displayName = ae.Content.displayName;
function oe({
  children: e,
  content: o,
  side: t,
  align: n
}) {
  const { disableTooltips: s } = C();
  return !o || s ? e : /* @__PURE__ */ d(go, { children: [
    /* @__PURE__ */ r(wo, { asChild: !0, children: e }),
    /* @__PURE__ */ r(
      Kt,
      {
        side: t,
        align: n,
        collisionPadding: 8,
        avoidCollisions: !0,
        children: o
      }
    )
  ] });
}
function fo(e, o) {
  const t = typeof (e == null ? void 0 : e.right) == "number", n = typeof (e == null ? void 0 : e.left) == "number";
  return t && !n ? "right" : n && !t || o === "rtl" ? "left" : "right";
}
const Ct = 450;
function B() {
  const [e, o] = L.useState(() => (window.top || window).innerWidth < Ct);
  return L.useEffect(() => {
    const t = window.top || window, n = () => {
      o(t.innerWidth < Ct);
    };
    return n(), t.addEventListener("resize", n), () => {
      t.removeEventListener("resize", n);
    };
  }, []), { isSmallScreen: e };
}
const ce = {
  transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  transitionDuration: "1000ms"
};
function V() {
  var w, u, v, z, M, b, S, I, E, f, D, j, R, g, T, ie, Ae, Fe, He, We, Le, $e, Be, Ue, Ye, Xe, qe, Ve, Ge, Ze, Ke, Qe, Je, et, tt, rt, ot, nt, st, at, it, lt, ct, dt, pt, mt, ht, ut;
  const { dir: e } = ze(), { isSmallScreen: o } = B(), { theme: t, inline: n } = C(), s = (q) => n ? "100%" : q, i = (q, we) => o ? `100dv${q}` : we, a = (q, we) => s(i(q, we)), l = fo((w = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : w.offset, e), c = {
    zIndex: ((u = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : u.zIndex) ?? 1e7,
    offset: {
      bottom: ((z = (v = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : v.offset) == null ? void 0 : z.bottom) ?? 20,
      right: ((b = (M = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : M.offset) == null ? void 0 : b.right) ?? (l === "right" ? 20 : "initial"),
      left: ((I = (S = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : S.offset) == null ? void 0 : I.left) ?? (l === "left" ? 20 : "initial")
    },
    size: {
      button: ((f = (E = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : E.size) == null ? void 0 : f.button) ?? 48,
      icon: ((j = (D = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : D.size) == null ? void 0 : j.icon) ?? 24
    }
  }, m = (() => {
    const q = l === "right" ? c.offset.right : c.offset.left;
    return typeof q != "number" ? 0 : q;
  })(), h = {
    palette: (t == null ? void 0 : t.palette) ?? "neutral",
    primaryColor: (t == null ? void 0 : t.primaryColor) ?? "hsl(0 0% 9%)",
    widgetTrigger: c,
    widgetContentContainer: {
      borderRadius: o ? "0px" : ((R = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : R.borderRadius) ?? "32px",
      zIndex: ((g = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : g.zIndex) ?? c.zIndex + 1,
      outline: ((T = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : T.outline) ?? "none",
      // was: '1px solid'
      outlineColor: ((ie = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : ie.outlineColor) ?? "hsl(0 0% 50% / .5)",
      boxShadow: ((Ae = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Ae.boxShadow) ?? "0 0px 100px 0px rgb(0 0 0 / 0.25)",
      transitionProperty: ((Fe = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Fe.transitionProperty) ?? "all",
      transitionTimingFunction: ((He = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : He.transitionTimingFunction) ?? ce.transitionTimingFunction,
      transitionDuration: ((We = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : We.transitionDuration) ?? ce.transitionDuration,
      offset: {
        side: o ? 0 : c.offset.bottom + c.size.button + Q.y * 2 + ((($e = (Le = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Le.offset) == null ? void 0 : $e.side) ?? 10),
        align: o ? 0 : m + (((Ue = (Be = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Be.offset) == null ? void 0 : Ue.align) ?? 0)
      }
    },
    screens: {
      welcome: {
        width: a("w", ((Xe = (Ye = t == null ? void 0 : t.screens) == null ? void 0 : Ye.welcome) == null ? void 0 : Xe.width) ?? "400px"),
        // By setting minHeight to 1px, a nice animation will play from 1px to the dynamic height of the content of the screen
        minHeight: a(
          "h",
          ((Ve = (qe = t == null ? void 0 : t.screens) == null ? void 0 : qe.welcome) == null ? void 0 : Ve.minHeight) ?? "1px"
        )
      },
      sessions: {
        width: a("w", ((Ze = (Ge = t == null ? void 0 : t.screens) == null ? void 0 : Ge.sessions) == null ? void 0 : Ze.width) ?? "450px"),
        height: a("h", ((Qe = (Ke = t == null ? void 0 : t.screens) == null ? void 0 : Ke.sessions) == null ? void 0 : Qe.height) ?? "600px")
      },
      chat: {
        width: a("w", ((et = (Je = t == null ? void 0 : t.screens) == null ? void 0 : Je.chat) == null ? void 0 : et.width) ?? "525px"),
        height: a("h", ((rt = (tt = t == null ? void 0 : t.screens) == null ? void 0 : tt.chat) == null ? void 0 : rt.height) ?? "700px"),
        withCanvas: {
          width: a(
            "w",
            ((st = (nt = (ot = t == null ? void 0 : t.screens) == null ? void 0 : ot.chat) == null ? void 0 : nt.withCanvas) == null ? void 0 : st.width) ?? "min(1050px, 100vw)"
          ),
          height: a(
            "h",
            ((lt = (it = (at = t == null ? void 0 : t.screens) == null ? void 0 : at.chat) == null ? void 0 : it.withCanvas) == null ? void 0 : lt.height) ?? "min(800px, 100vh)"
          ),
          transitionTimingFunction: ((pt = (dt = (ct = t == null ? void 0 : t.screens) == null ? void 0 : ct.chat) == null ? void 0 : dt.withCanvas) == null ? void 0 : pt.transitionTimingFunction) ?? ce.transitionTimingFunction,
          transitionDuration: ((ut = (ht = (mt = t == null ? void 0 : t.screens) == null ? void 0 : mt.chat) == null ? void 0 : ht.withCanvas) == null ? void 0 : ut.transitionDuration) ?? ce.transitionDuration
        }
      }
    }
  }, k = {
    // Subtract the offset.bottom twice so that it adds a bit of padding to the top
    // Subtract the distance between the trigger and the widget content container
    // Subtract the invisible padding of the trigger (for the wobble effect)
    maxHeight: a(
      "h",
      `calc(
        100vh 
        - ${h.widgetTrigger.offset.bottom}px
        - ${h.widgetContentContainer.offset.side}px
        - ${Q.y * 2}px
      )`
    ),
    // Subtract the offset.right twice so that it adds a bit of padding to the left
    maxWidth: a(
      "w",
      `calc(
        100vw 
        - ${m * 2}px
      )`
    ),
    minHeight: a(
      "h",
      `min(
        ${h.screens.welcome.minHeight}, 
        ${h.screens.sessions.height}, 
        ${h.screens.chat.height}
      )`
    ),
    minWidth: a(
      "w",
      `min(
        ${h.screens.welcome.width}, 
        ${h.screens.sessions.width}, 
        ${h.screens.chat.width}
      )`
    )
  };
  return {
    theme: h,
    triggerSide: l,
    computed: k,
    cssVars: xo({
      palette: h.palette,
      primary: h.primaryColor
    })
  };
}
function xo({
  palette: e,
  primary: o
}) {
  const t = Qt(e), n = ft(o).toHsl(), s = ft(o).isLight() ? t[950] : t[50];
  return {
    "--opencx-primary": `${n.h} ${n.s * 100}% ${n.l * 100}%`,
    "--opencx-primary-foreground": s,
    "--opencx-background": t[100],
    "--opencx-foreground": t[950],
    "--opencx-destructive": "0 72.2% 50.6%",
    "--opencx-destructive-foreground": t[50],
    "--opencx-accent": t[200],
    "--opencx-accent-foreground": "var(--opencx-foreground)",
    "--opencx-secondary": t[200],
    "--opencx-secondary-foreground": "var(--opencx-foreground)",
    "--opencx-muted": t[200],
    "--opencx-muted-foreground": t[500],
    "--opencx-input": t[300],
    "--opencx-border": t[300],
    "--opencx-ring": "var(--opencx-foreground)"
  };
}
function Qt(e) {
  const o = {
    50: "0 0% 98%",
    100: "0 0% 96.1%",
    200: "0 0% 89.8%",
    300: "0 0% 83.1%",
    400: "0 0% 63.9%",
    500: "0 0% 45.1%",
    600: "0 0% 32.2%",
    700: "0 0% 25.1%",
    800: "0 0% 14.9%",
    900: "0 0% 9%",
    950: "0 0% 3.9%"
  }, t = {
    50: "60 9.1% 97.8%",
    100: "60 4.8% 95.9%",
    200: "20 5.9% 90%",
    300: "24 5.7% 82.9%",
    400: "24 5.4% 63.9%",
    500: "25 5.3% 44.7%",
    600: "33.3 5.5% 32.4%",
    700: "30 6.3% 25.1%",
    800: "12 6.5% 15.1%",
    900: "24 9.8% 10%",
    950: "20 14.3% 4.1%"
  }, n = {
    50: "0 0% 98%",
    100: "240 4.8% 95.9%",
    200: "240 5.9% 90%",
    300: "240 4.9% 83.9%",
    400: "240 5% 64.9%",
    500: "240 3.8% 46.1%",
    600: "240 5.2% 33.9%",
    700: "240 5.3% 26.1%",
    800: "240 3.7% 15.9%",
    900: "240 5.9% 10%",
    950: "240 10% 3.9%"
  }, s = {
    50: "210 40% 98%",
    100: "210 40% 96.1%",
    200: "214.3 31.8% 91.4%",
    300: "212.7 26.8% 83.9%",
    400: "215 20.2% 65.1%",
    500: "215.4 16.3% 46.9%",
    600: "215.3 19.3% 34.5%",
    700: "215.3 25% 26.7%",
    800: "217.2 32.6% 17.5%",
    900: "222.2 47.4% 11.2%",
    950: "222.2 84% 4.9%"
  };
  switch (e) {
    case "neutral":
      return o;
    case "stone":
      return t;
    case "zinc":
      return n;
    case "slate":
      return s;
    default:
      return F(e, Qt.name), o;
  }
}
function Jt() {
  const { contentIframeRef: e } = A(), { inline: o } = C();
  return {
    setWidth: (t) => {
      var n;
      (n = e == null ? void 0 : e.current) == null || n.style.setProperty(
        "--opencx-widget-width",
        o ? "100%" : t
      );
    },
    setHeight: (t) => {
      var n;
      (n = e == null ? void 0 : e.current) == null || n.style.setProperty(
        "--opencx-widget-height",
        o ? "100%" : t
      );
    }
  };
}
function Pe({
  width: e,
  height: o
}) {
  const { isSmallScreen: t } = B(), { setWidth: n, setHeight: s } = Jt();
  se(() => {
    e && n(e), o && s(o);
  }, [t, o, e, n, s]);
}
const zt = vr;
function ne({
  name: e,
  className: o
}) {
  const t = (() => {
    switch (e) {
      case "Check":
        return Er;
      case "CheckCheck":
        return Dr;
      case "CircleCheck":
        return Ft;
      case "CircleCheckBig":
        return Mr;
      case "CircleX":
        return Tr;
      case "Expand":
        return Ir;
      case "Maximize":
        return _r;
      case "Maximize2":
        return Sr;
      case "Minimize":
        return Nr;
      case "Minimize2":
        return zr;
      case "Shrink":
        return Cr;
      case "SquareCheck":
        return kr;
      case "SquareCheckBig":
        return yr;
      case "SquareX":
        return br;
      case "X":
        return Ne;
      case void 0:
        return zt;
      default:
        return F(e, ne.name), zt;
    }
  })();
  return /* @__PURE__ */ r(t, { className: p("size-4", o) });
}
function vo() {
  var t;
  const e = X(), o = (t = e.config.customComponents) == null ? void 0 : t.headerBottom;
  return o ? /* @__PURE__ */ r(o, { ...e }) : null;
}
function bo({ fallback: e }) {
  var n;
  const o = X(), t = (n = o.config.customComponents) == null ? void 0 : n.headerTitle;
  return t ? /* @__PURE__ */ r(t, { ...o }) : e;
}
function je() {
  const {
    widgetCtx: { org: e }
  } = A(), {
    routerState: { screen: o }
  } = H(), { textContent: t } = C();
  return (() => {
    var s, i;
    switch (o) {
      case "chat":
        return (s = t == null ? void 0 : t.chatScreen) == null ? void 0 : s.headerTitle;
      case "sessions":
        return (i = t == null ? void 0 : t.sessionsScreen) == null ? void 0 : i.headerTitle;
      case "welcome":
        return;
      default:
        F(o, je.name);
        return;
    }
  })() ?? e.name ?? "Chat";
}
function yo(e) {
  switch (e) {
    case "chat":
      return x("chat/header");
    case "sessions":
      return x("sessions/header");
    case "welcome":
      return;
    default:
      F(e, je.name);
      return;
  }
}
function ko() {
  const { router: e } = C(), {
    routerState: { screen: o },
    toSessionsScreen: t
  } = H();
  return o !== "chat" || e != null && e.chatScreenOnly ? null : /* @__PURE__ */ r(
    N,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: t,
      children: /* @__PURE__ */ r(Rr, { className: "size-4 rtl:-scale-100" })
    }
  );
}
function Co({
  button: e
}) {
  const { setIsOpen: o } = K(), { isSmallScreen: t } = B(), n = X();
  return t && e.hideOnSmallScreen || !t && e.hideOnLargeScreen ? null : /* @__PURE__ */ r(
    N,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: () => {
        var i;
        e.handleClick ? e.handleClick() : o(!1), (i = e.onClicked) == null || i.call(e, n);
      },
      children: /* @__PURE__ */ r(ne, { name: e.icon })
    }
  );
}
function ke({
  button: e
}) {
  const [o, t] = P(!1), {
    routerState: { screen: n }
  } = H(), { isSmallScreen: s } = B(), { theme: i } = V(), { setWidth: a, setHeight: l } = Jt(), c = X();
  if (n !== "chat" && n !== "sessions") return null;
  const m = (() => {
    switch (n) {
      case "chat":
        return i.screens.chat.height;
      case "sessions":
        return i.screens.sessions.height;
      default:
        return F(n, ke.name), i.screens.chat.height;
    }
  })(), h = (() => {
    switch (n) {
      case "chat":
        return i.screens.chat.width;
      case "sessions":
        return i.screens.sessions.width;
      default:
        return F(n, ke.name), i.screens.chat.width;
    }
  })(), k = () => {
    var w;
    t((u) => {
      const v = !u;
      return l(v ? "100vh" : m), a(v ? `max(40vw, ${h})` : h), v;
    }), (w = e.onClicked) == null || w.call(e, c);
  };
  return s && e.hideOnSmallScreen || !s && e.hideOnLargeScreen ? null : /* @__PURE__ */ r(
    N,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: k,
      children: /* @__PURE__ */ r(
        ne,
        {
          name: e.icon || (o ? e.shrinkIcon : e.expandIcon)
        }
      )
    }
  );
}
function er({
  button: e
}) {
  var M, b;
  const { close: o } = he(), { widgetCtx: t } = A(), { setIsOpen: n } = K(), { resolveSession: s, sessionState: i } = $(), { isSmallScreen: a } = B(), l = X(), c = !i.session, m = ((M = i.session) == null ? void 0 : M.isOpened) === !1, h = e.onResolved || "stay-in-chat", k = e.behaviorBeforeSessionCreation || "disabled", w = e.behaviorIfSessionIsResolved || "disabled", u = !!(i.isResolvingSession || c && k === "disabled" || m && w === "disabled"), v = async () => {
    const { success: S, error: I } = await s();
    if (o(), !S)
      return console.error(I), !1;
    switch (h) {
      case "stay-in-chat":
        break;
      case "close-widget":
        n(!1);
        break;
      case "reset-chat":
        t.resetChat();
        break;
      case "reset-chat-and-close-widget":
        n(!1), t.resetChat();
        break;
      default:
        F(h, er.name);
        break;
    }
    return !0;
  }, z = () => {
    if (c)
      switch (k) {
        case "disabled":
          return;
        case "close-widget":
          n(!1);
          break;
        default:
          F(
            k,
            z.name
          );
      }
    if (m)
      switch (w) {
        case "disabled":
          return;
        case "close-widget":
          n(!1);
          break;
        case "reset-chat":
          t.resetChat();
          break;
        case "reset-chat-and-close-widget":
          n(!1), setTimeout(() => {
            t.resetChat();
          }, 200);
          break;
        default:
          F(
            w,
            z.name
          );
      }
  };
  return a && e.hideOnSmallScreen || !a && e.hideOnLargeScreen ? null : ((b = e.confirmation) == null ? void 0 : b.type) === "modal" && !m && !c ? /* @__PURE__ */ r(
    ge,
    {
      trigger: /* @__PURE__ */ r(
        N,
        {
          variant: "ghost",
          size: "fit",
          className: "rounded-full",
          disabled: u,
          onClick: () => {
            var S;
            return (S = e.onClicked) == null ? void 0 : S.call(e, l);
          },
          children: /* @__PURE__ */ r(ne, { name: e.icon })
        }
      ),
      children: /* @__PURE__ */ d(ue, { children: [
        /* @__PURE__ */ r(Se, { children: /* @__PURE__ */ r(Ie, { children: e.confirmation.title || "Close conversation" }) }),
        /* @__PURE__ */ r(_e, { children: /* @__PURE__ */ r(Te, { children: e.confirmation.description || "Are you sure you want to close this conversation?" }) }),
        /* @__PURE__ */ d(Xt, { children: [
          /* @__PURE__ */ r(
            N,
            {
              variant: "secondary",
              onClick: o,
              disabled: i.isResolvingSession,
              children: e.confirmation.cancelButtonText || "No"
            }
          ),
          /* @__PURE__ */ r(
            N,
            {
              variant: "destructive",
              onClick: async () => {
                var I, E;
                await v() && ((E = (I = e.confirmation) == null ? void 0 : I.onResolved) == null || E.call(I, l));
              },
              disabled: i.isResolvingSession,
              children: e.confirmation.confirmButtonText || "Yes"
            }
          )
        ] })
      ] })
    }
  ) : /* @__PURE__ */ r(
    N,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: () => {
        var S;
        m || c ? z() : v(), (S = e.onClicked) == null || S.call(e, l);
      },
      disabled: u,
      children: /* @__PURE__ */ r(ne, { name: e.icon })
    }
  );
}
function Ce({ button: e }) {
  switch (e.functionality) {
    case "close-widget":
      return /* @__PURE__ */ r(Co, { button: e });
    case "expand-shrink":
      return /* @__PURE__ */ r(ke, { button: e });
    case "resolve-session":
      return /* @__PURE__ */ r(er, { button: e });
    default:
      return F(e, Ce.name), null;
  }
}
const zo = {
  functionality: "close-widget",
  hideOnLargeScreen: !0,
  icon: "X"
};
function No() {
  const {
    routerState: { screen: e }
  } = H(), { headerButtons: o } = C(), t = e === "chat" ? o == null ? void 0 : o.chatScreen : e === "sessions" ? o == null ? void 0 : o.sessionsScreen : [];
  return !t || t.length === 0 ? /* @__PURE__ */ r(Ce, { button: zo }) : /* @__PURE__ */ r(J, { children: t.map((n) => /* @__PURE__ */ r(
    Ce,
    {
      button: n
    },
    `${n.functionality}-${n.icon}`
  )) });
}
function tr() {
  const {
    routerState: { screen: e }
  } = H(), o = yo(e), t = je();
  return /* @__PURE__ */ d("header", { ...o, className: "py-2 px-4 shrink-0", children: [
    /* @__PURE__ */ d("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ r(ko, {}),
      /* @__PURE__ */ r(
        "div",
        {
          className: p(
            "flex-1 h-8 flex items-center",
            e === "sessions" && "ps-2"
          ),
          children: /* @__PURE__ */ r(
            bo,
            {
              fallback: /* @__PURE__ */ r("h2", { className: "font-semibold", children: t })
            }
          )
        }
      ),
      /* @__PURE__ */ r(No, {})
    ] }),
    /* @__PURE__ */ r(vo, {})
  ] });
}
function rr({ className: e }) {
  return /* @__PURE__ */ r(Pr, { className: p("size-4 animate-spin", e) });
}
function So() {
  const {
    messagesState: { isInitialFetchLoading: e }
  } = O(), { isSmallScreen: o } = B(), { activeMode: t, Component: n } = Et();
  return {
    isCanvasOpen: !e && !o && !!t && !!n
  };
}
function _o() {
  const e = X(), { activeMode: o, Component: t } = Et(), { sendMessage: n } = O(), { createStateCheckpoint: s } = $(), [i, a] = P(!1), l = async (c) => {
    try {
      a(!0), await n(c);
    } catch (m) {
      console.error(m);
    } finally {
      a(!1);
    }
  };
  return !o || !t ? null : /* @__PURE__ */ r(
    t,
    {
      ...e,
      mode: o,
      createStateCheckpoint: s,
      sendMessage: l,
      isSendingMessage: i
    }
  );
}
function G() {
  const { dir: e } = ze(), o = C();
  return Dt(() => {
    const t = Gr(o.language) ? o.language : "en";
    return {
      t: (n) => Zr(n, t, o.translationOverrides),
      language: t,
      dir: t === "ar" ? "rtl" : "ltr",
      hostDocumentDir: e
    };
  }, [o.language, e]);
}
const W = L.forwardRef(
  (e, o) => {
    var t, n, s;
    return /* @__PURE__ */ r(
      y,
      {
        ...e,
        ref: o,
        className: p("overflow-hidden", e.className),
        overrides: {
          initial: { height: 0, opacity: 0, ...(t = e.overrides) == null ? void 0 : t.initial },
          animate: { height: "auto", opacity: 1, ...(n = e.overrides) == null ? void 0 : n.animate },
          exit: { height: 0, opacity: 0, ...(s = e.overrides) == null ? void 0 : s.exit }
        }
      }
    );
  }
);
W.displayName = "MotionDiv__VerticalReveal";
const Io = [
  {
    label: "Terrible",
    value: 1,
    emoji: "😡"
  },
  {
    label: "Poor",
    value: 2,
    emoji: "😞"
  },
  {
    label: "Okay",
    value: 3,
    emoji: "😐"
  },
  {
    label: "Good",
    value: 4,
    emoji: "😊"
  },
  {
    label: "Great",
    value: 5,
    emoji: "😍"
  }
];
function To() {
  const { isSmallScreen: e } = B(), { t: o } = G(), {
    submitCsat: t,
    isCsatRequested: n,
    isCsatSubmitted: s,
    submittedScore: i,
    submittedFeedback: a
  } = Rt(), [l, c] = P(null), [m, h] = P(null), k = (u) => {
    c((v) => v === u ? null : u);
  }, w = () => {
    l && t({
      score: l,
      feedback: m || void 0
    });
  };
  return !n && !s ? null : /* @__PURE__ */ d("div", { className: "w-1/2 min-w-80 max-w-96 mx-auto overflow-hidden", children: [
    /* @__PURE__ */ r(_, { mode: "wait", children: n && !l ? /* @__PURE__ */ r(W, { children: /* @__PURE__ */ r("p", { className: "text-sm text-muted-foreground text-center pt-2", children: o("csat_title") }) }, "csat-requested-title") : s ? /* @__PURE__ */ r(W, { children: /* @__PURE__ */ r("p", { className: "text-sm text-muted-foreground text-center pt-2", children: o("csat_submitted_title") }) }, "csat-submitted-title") : null }),
    /* @__PURE__ */ r(
      "div",
      {
        dir: "ltr",
        className: p(
          "flex gap-4 justify-between pt-2 px-2 pb-2",
          "transition-all",
          s && "gap-0 justify-center"
        ),
        children: Io.map((u) => /* @__PURE__ */ r(
          N,
          {
            variant: u.value === l ? "secondary" : "ghost",
            size: "selfless",
            className: p(
              "transition-all overflow-hidden",
              "text-2xl size-8 rounded-full",
              "opacity-35",
              "hover:opacity-100",
              !l && "opacity-100",
              u.value === l && "opacity-100",
              s && u.value !== i && "opacity-0 size-0",
              s && u.value === i && "opacity-100 size-fit text-4xl"
            ),
            onClick: n ? () => k(u.value) : void 0,
            children: u.emoji
          },
          u.value
        ))
      }
    ),
    /* @__PURE__ */ r(_, { mode: "wait", children: (l || i) && /* @__PURE__ */ r(W, { children: /* @__PURE__ */ d("div", { className: "pb-2 px-2 flex items-end", children: [
      /* @__PURE__ */ r(
        "textarea",
        {
          rows: 3,
          className: p(
            "transition-all",
            "max-h-40 [field-sizing:content]",
            "w-full resize-none",
            "bg-transparent outline-none",
            "placeholder:text-muted-foreground",
            // 16px on mobiles prevents auto-zoom on the input when focused
            e ? "text-[16px]" : "text-sm",
            s && "text-center"
          ),
          value: s ? a || "" : m || "",
          onChange: n ? (u) => h(u.target.value) : void 0,
          readOnly: s,
          placeholder: n ? o("csat_feedback_placeholder") : void 0
        }
      ),
      /* @__PURE__ */ r(
        N,
        {
          size: "fit",
          onClick: w,
          disabled: !l,
          className: p(
            "transition-all overflow-hidden",
            "rounded-full size-8 flex items-center justify-center p-0",
            s && "opacity-0 size-0"
          ),
          children: /* @__PURE__ */ r(Ht, { className: "size-4" })
        }
      )
    ] }) }, "feedback-box") }),
    /* @__PURE__ */ r(
      "div",
      {
        className: p("h-0 transition-[height]", s && "h-4")
      }
    )
  ] });
}
function Oe({
  suggestion: e,
  className: o,
  ...t
}) {
  const { sendMessage: n } = O(), s = () => {
    const i = e.trim();
    i && n({ content: i });
  };
  return /* @__PURE__ */ r(
    N,
    {
      ...x("chat/suggested_reply_btn"),
      size: "sm",
      className: p("rounded-xl w-fit", o),
      ...t,
      onClick: s,
      children: e
    }
  );
}
function Mo() {
  const { t: e } = G(), o = [e("i_need_more_help"), e("this_was_helpful")];
  return /* @__PURE__ */ r(
    "div",
    {
      ...x("chat/might_solve_user_issue_suggested_replies_container"),
      className: "flex items-center gap-2 p-2 pb-0 flex-wrap",
      children: o.map((t) => /* @__PURE__ */ r(
        Oe,
        {
          suggestion: t,
          className: "flex-1"
        },
        t
      ))
    }
  );
}
function Do() {
  const { requireInitialQuestion: e, initialQuestions: o } = C(), { messagesState: t } = O();
  return e === !0 && t.messages.length === 0 && (o == null ? void 0 : o.some((n) => n.trim().length > 0)) === !0;
}
function Nt() {
  const { sessionState: e } = $(), { chatFooterItems: o } = C(), t = !!e.session && !e.session.isOpened, n = !t;
  return /* @__PURE__ */ r(_, { mode: "wait", children: o == null ? void 0 : o.map((s, i) => s.showWhenSessionIsOpen === !1 && n || s.showWhenSessionIsResolved === !1 && t ? null : /* @__PURE__ */ r(W, { children: /* @__PURE__ */ r("div", { className: "pb-2 text-center text-xs", children: /* @__PURE__ */ r(Me, { children: s.message }) }) }, `${s.message}-${i}`)) });
}
function Eo({
  file: { status: e, file: o, error: t },
  onCancel: n
}) {
  const [s, i] = P(
    null
  );
  se(() => {
    if (!o.type.startsWith("image/")) return;
    const c = new FileReader();
    return c.onload = () => i(c.result), c.onerror = () => console.error("Error reading file"), c.readAsDataURL(o), () => c.abort();
  }, [o]);
  const a = () => {
    switch (e) {
      case "uploading":
        return /* @__PURE__ */ r(Ar, { className: "size-4 animate-spin" });
      case "error":
        return /* @__PURE__ */ r(Or, { className: "size-4 text-destructive" });
      default:
        return null;
    }
  }, l = () => {
    const c = o.type.split("/")[0];
    return c === "image" && s ? /* @__PURE__ */ r(
      "img",
      {
        src: typeof s == "string" ? s : "",
        className: "object-cover bg-secondary size-full",
        alt: o.name
      }
    ) : c === "audio" ? /* @__PURE__ */ r(Fr, { className: "size-4 text-muted-foreground" }) : c === "video" ? /* @__PURE__ */ r(Hr, { className: "size-4 text-muted-foreground" }) : o.type === "application/pdf" ? /* @__PURE__ */ r(Ot, { className: "size-4 text-muted-foreground" }) : Ut({ type: o.type, name: o.name }) ? /* @__PURE__ */ r(At, { className: "size-4 text-muted-foreground" }) : /* @__PURE__ */ r(Wr, { className: "size-4 text-muted-foreground" });
  };
  return /* @__PURE__ */ r(
    oe,
    {
      side: "bottom",
      content: e === "error" ? /* @__PURE__ */ d("span", { className: "text-destructive", children: [
        "Failed to upload: ",
        t
      ] }) : o.name,
      children: /* @__PURE__ */ d(
        "div",
        {
          className: p(
            e === "uploading" && "opacity-50",
            "group",
            "size-12 border rounded-2xl overflow-hidden relative",
            "flex items-center justify-center shrink-0"
          ),
          children: [
            /* @__PURE__ */ r("div", { className: "absolute inset-0 flex items-center justify-center", children: a() }),
            /* @__PURE__ */ r(
              "button",
              {
                type: "button",
                className: p(
                  "absolute bg-black/50 inset-0 size-full z-10 opacity-0",
                  "flex items-center justify-center",
                  "opacity-0 group-hover:opacity-100 transition"
                ),
                onClick: n,
                children: /* @__PURE__ */ r(Ne, { className: "size-4 text-primary-foreground" })
              }
            ),
            /* @__PURE__ */ r(l, {})
          ]
        }
      )
    }
  );
}
const Ro = 25 * 1024 * 1024;
function Po() {
  var R;
  const { isSmallScreen: e } = B(), o = U(null), { sendMessage: t } = O(), { sessionState: n } = $(), { disableSendingWhenAwaitingAIReply: s } = C(), { t: i } = G(), [a, l] = P(""), {
    allFiles: c,
    emptyTheFiles: m,
    handleCancelUpload: h,
    appendFiles: k,
    isUploading: w,
    successFiles: u
  } = mr(), v = !!((R = n.session) != null && R.isHandedOff), { isAwaitingBotReply: z } = Pt(), M = s !== !1 && z, b = (g) => {
    k(g);
  }, S = !a.trim() && u.length === 0, I = async () => {
    if (M || S) return;
    w && console.info("please wait for the file(s) to upload");
    const g = a.trim();
    t({
      content: g,
      attachments: u.flatMap(
        (T) => T.fileUrl ? [
          {
            url: T.fileUrl,
            type: T.file.type,
            name: T.file.name,
            id: T.id,
            size: T.file.size
          }
        ] : []
      )
    }), l(""), m();
  }, {
    getRootProps: E,
    getInputProps: f,
    open: D
  } = Kr({
    onDrop: b,
    noClick: !0,
    onDropRejected() {
      console.error("unsupported file type, or the file is too large");
    },
    maxSize: Ro,
    accept: v ? {
      "text/*": [".txt"],
      "image/*": [".png", ".jpg", ".jpeg", ".gif"],
      "application/pdf": [".pdf"],
      ...xt,
      ...vt
    } : {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/gif": [".gif"],
      "image/webp": [".webp"],
      "application/pdf": [".pdf"],
      ...xt,
      ...vt
    }
  }), j = (g) => {
    const T = g.clipboardData;
    T && T.files.length > 0 && b(Array.from(T.files));
  };
  return /* @__PURE__ */ d(
    "div",
    {
      ...x("chat/input_box/root"),
      className: "p-2 relative space-y-1",
      ...E(),
      children: [
        /* @__PURE__ */ r("input", { ...f() }),
        /* @__PURE__ */ d(
          "div",
          {
            ...x("chat/input_box/inner_root"),
            className: p(
              "transition-all",
              "bg-white",
              // 'border',
              "relative rounded-3xl flex flex-col gap-2 p-2",
              "hover:border-primary focus-within:border-primary"
            ),
            children: [
              /* @__PURE__ */ d(
                "div",
                {
                  ...x("chat/input_box/textarea_and_attachments_container"),
                  className: "flex flex-col gap-2",
                  children: [
                    c.length > 0 && /* @__PURE__ */ r(
                      "div",
                      {
                        ...x("chat/input_box/attachments_container"),
                        className: "flex items-center gap-1",
                        children: /* @__PURE__ */ r(_, { mode: "popLayout", children: c.map((g) => /* @__PURE__ */ r(y, { snapExit: !0, children: /* @__PURE__ */ r(
                          Eo,
                          {
                            onCancel: () => h(g.id),
                            file: g
                          }
                        ) }, g.id)) })
                      }
                    ),
                    /* @__PURE__ */ r(
                      "textarea",
                      {
                        ...x("chat/input_box/textarea"),
                        onPaste: j,
                        ref: o,
                        id: "chat-input",
                        value: a,
                        rows: 3,
                        className: p(
                          /** Match the border radius of the container */
                          // INPUT_CONTAINER_B_RADIUS,
                          "max-h-16 [field-sizing:content]",
                          "w-full resize-none px-2",
                          c.length === 0 && "pt-1",
                          "bg-transparent outline-none",
                          "placeholder:text-muted-foreground",
                          // 16px on mobiles prevents auto-zoom on the input when focused
                          e ? "text-[16px]" : "text-sm"
                        ),
                        onChange: (g) => l(g.target.value),
                        onKeyDown: async (g) => {
                          g.key === "Enter" && !g.shiftKey && (g.preventDefault(), I());
                        },
                        placeholder: i("write_a_message_placeholder")
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ d("div", { className: "gap-2 flex justify-between", children: [
                /* @__PURE__ */ r(
                  oe,
                  {
                    side: "top",
                    align: "start",
                    content: "attach images, videos, PDFs, or spreadsheets (maximum size 25mb)",
                    children: /* @__PURE__ */ r(
                      N,
                      {
                        onClick: D,
                        size: "fit",
                        variant: "ghost",
                        className: p(
                          "rounded-full size-8 flex items-center justify-center p-0 overflow-hidden"
                        ),
                        children: /* @__PURE__ */ r(_, { mode: "wait", children: M ? /* @__PURE__ */ r(y, { children: /* @__PURE__ */ r(wt, { className: "size-4 opacity-50" }) }, "paper-clip-disabled") : /* @__PURE__ */ r(y, { children: /* @__PURE__ */ r(wt, { className: "size-4" }) }, "paper-clip") })
                      }
                    )
                  }
                ),
                /* @__PURE__ */ r(oe, { content: "send message", side: "top", align: "end", children: /* @__PURE__ */ r(
                  N,
                  {
                    size: "fit",
                    onClick: I,
                    disabled: M || w || S,
                    className: "rounded-full size-8 flex items-center justify-center p-0",
                    children: /* @__PURE__ */ r(_, { mode: "wait", children: M || w ? /* @__PURE__ */ r(y, { snapExit: !0, children: /* @__PURE__ */ r(jr, { className: "size-4 animate-spin animate-iteration-infinite" }) }, "loading") : /* @__PURE__ */ r(y, { snapExit: !0, children: /* @__PURE__ */ r(Ht, { className: "size-4" }) }, "send") })
                  }
                ) })
              ] })
            ]
          }
        )
      ]
    }
  );
}
function St() {
  const { widgetCtx: e } = A(), { router: o } = C(), { canCreateNewSession: t } = $(), { toSessionsScreen: n } = H(), { t: s } = G();
  return /* @__PURE__ */ r(J, { children: t || o != null && o.chatScreenOnly ? /* @__PURE__ */ r(N, { onClick: e.resetChat, className: "rounded-2xl w-full", children: s("new_conversation") }) : /* @__PURE__ */ r(N, { onClick: n, className: "rounded-2xl w-full", children: s("back_to_conversations") }) });
}
function jo() {
  const { t: e } = G(), { isCsatRequested: o, isCsatSubmitted: t } = Rt();
  return /* @__PURE__ */ r("div", { className: "p-2", children: /* @__PURE__ */ r("div", { className: "p-2 bg-muted rounded-3xl", children: /* @__PURE__ */ r(_, { mode: "wait", children: o || t ? /* @__PURE__ */ d(W, { children: [
    /* @__PURE__ */ r(To, {}),
    /* @__PURE__ */ r(_, { mode: "wait", children: t && /* @__PURE__ */ r(W, { children: /* @__PURE__ */ r(St, {}) }, "new-conv-or-back-to-convs-button") })
  ] }, "csat") : /* @__PURE__ */ d(W, { children: [
    /* @__PURE__ */ d("div", { className: "ps-2 flex items-center gap-1 pb-2", children: [
      /* @__PURE__ */ r(Ft, { className: "size-4 text-emerald-600" }),
      /* @__PURE__ */ r("h2", { className: "text-sm font-medium", children: e("your_issue_has_been_resolved") })
    ] }),
    /* @__PURE__ */ r(St, {})
  ] }, "session-closed") }) }) });
}
function Oo() {
  var l;
  const { initialQuestions: e, initialQuestionsPosition: o, thisWasHelpfulOrNot: t } = C(), { sessionState: n } = $(), { messagesState: s } = O(), i = s.messages.length === 0, a = Do();
  return /* @__PURE__ */ r("footer", { children: /* @__PURE__ */ r(_, { mode: "wait", children: n.session && !((l = n.session) != null && l.isOpened) ? /* @__PURE__ */ d(W, { children: [
    /* @__PURE__ */ r(jo, {}),
    /* @__PURE__ */ r(Nt, {})
  ] }, "session-closed") : /* @__PURE__ */ d(W, { children: [
    s.lastAIResMightSolveUserIssue && (t == null ? void 0 : t.enabled) !== !1 && /* @__PURE__ */ r(Mo, {}),
    i && e && o !== "below-initial-messages" && /* @__PURE__ */ r(
      "div",
      {
        className: p(
          "flex items-center flex-row justify-end gap-2 flex-wrap px-2",
          a && "pb-4"
        ),
        children: e == null ? void 0 : e.map((c, m) => /* @__PURE__ */ r(
          Oe,
          {
            suggestion: c
          },
          `${c}-${m}`
        ))
      }
    ),
    !a && /* @__PURE__ */ r(Po, {}),
    /* @__PURE__ */ r(Nt, {})
  ] }, "chat-input") }) });
}
function Ao({
  isFirstInGroup: e,
  isLastInGroup: o,
  isAloneInGroup: t,
  ...n
}) {
  const { componentStore: s } = A();
  if (n.type !== "AGENT" && n.type !== "AI") return null;
  if (n.data.action) {
    const a = s.getComponent(n.data.action.name);
    if (a)
      return /* @__PURE__ */ r(
        a,
        {
          ...n,
          id: n.id,
          isFirstInGroup: e,
          isLastInGroup: o,
          isAloneInGroup: t
        }
      );
  }
  const i = s.getComponent(n.component);
  return i ? /* @__PURE__ */ r(
    i,
    {
      ...n,
      id: n.id,
      isFirstInGroup: e,
      isLastInGroup: o,
      isAloneInGroup: t
    }
  ) : /* @__PURE__ */ r(
    be,
    {
      ...n,
      isFirstInGroup: e,
      isLastInGroup: o,
      isAloneInGroup: t
    }
  );
}
function or({
  messages: e,
  className: o,
  containerClassName: t
}) {
  var a, l;
  const { timestamps: n } = C();
  if (!((a = n == null ? void 0 : n.perMessageGroup) != null && a.enabled))
    return null;
  const s = (l = e[e.length - 1]) == null ? void 0 : l.timestamp;
  if (!s) return null;
  const i = (() => {
    try {
      return new Date(s).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: !0
      });
    } catch (c) {
      return console.error(c), null;
    }
  })();
  return i ? /* @__PURE__ */ r("div", { className: t, children: /* @__PURE__ */ r("span", { className: p("text-xs text-muted-foreground", o), children: i }) }) : null;
}
function pe({
  messages: e,
  agent: o,
  suggestedReplies: t
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      ...x("chat/agent_msg_group/root"),
      className: p("flex items-end gap-2"),
      children: [
        /* @__PURE__ */ r(oe, { content: o == null ? void 0 : o.name, side: "right", align: "end", children: /* @__PURE__ */ r(
          ye,
          {
            ...x("chat/agent_msg_group/root/avatar"),
            agent: o,
            className: "hidden"
          }
        ) }),
        /* @__PURE__ */ d("div", { className: p("flex-1 flex flex-col gap-1"), children: [
          /* @__PURE__ */ d(
            "div",
            {
              ...x("chat/agent_msg_group/avatar_and_msgs/root"),
              className: p("flex items-end gap-2"),
              children: [
                /* @__PURE__ */ r(oe, { content: o == null ? void 0 : o.name, side: "right", align: "end", children: /* @__PURE__ */ r(
                  ye,
                  {
                    ...x("chat/agent_msg_group/avatar_and_msgs/avatar"),
                    agent: o
                  }
                ) }),
                /* @__PURE__ */ d(
                  "div",
                  {
                    ...x("chat/agent_msg_group/avatar_and_msgs/msgs"),
                    className: p("flex-1 flex flex-col gap-1"),
                    children: [
                      e.map((n, s, i) => /* @__PURE__ */ r(
                        Ao,
                        {
                          isFirstInGroup: s === 0,
                          isLastInGroup: s === i.length - 1,
                          isAloneInGroup: i.length === 1,
                          ...n
                        },
                        n.id
                      )),
                      /* @__PURE__ */ r(or, { messages: e })
                    ]
                  }
                )
              ]
            }
          ),
          t && t.length > 0 && /* @__PURE__ */ r(
            "div",
            {
              ...x("chat/agent_msg_group/suggestions"),
              className: p("flex flex-col gap-1 ps-8"),
              children: t == null ? void 0 : t.map((n, s) => /* @__PURE__ */ r(
                Oe,
                {
                  suggestion: n
                },
                `${n}-${s}`
              ))
            }
          )
        ] })
      ]
    }
  );
}
function Fo() {
  var t, n;
  const e = X();
  if ((t = e.session) != null && t.isOpened || !e.session) return null;
  const o = (n = e.config.customComponents) == null ? void 0 : n.onSessionResolved;
  return o ? /* @__PURE__ */ r(o, { ...e }) : null;
}
function Ho({
  message: e,
  isFirstInGroup: o,
  isLastInGroup: t,
  isAloneInGroup: n
}) {
  var s;
  return /* @__PURE__ */ d(
    "div",
    {
      ...x("chat/user_msg/root"),
      className: "w-5/6 flex flex-col items-end gap-1",
      children: [
        e.attachments && e.attachments.length > 0 && /* @__PURE__ */ r("div", { className: "w-full flex gap-1 flex-wrap justify-end", children: (s = e.attachments) == null ? void 0 : s.map((i) => /* @__PURE__ */ r(Vt, { attachment: i }, i.id)) }),
        e.content.length > 0 && /* @__PURE__ */ r(
          "div",
          {
            ...x("chat/user_msg/msg"),
            "data-first": o,
            "data-last": t,
            "data-alone": n,
            className: p(
              "transition-all",
              "w-fit py-3 px-4 rounded-3xl text-sm",
              "bg-primary text-primary-foreground",
              "break-words [word-break:break-word]",
              // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
              "whitespace-pre-wrap",
              // We're using the booleans directly here, not the data attributes, to make any external styling more specific than this
              o && !n && "rounded-br-md",
              t && !n && "rounded-tr-md",
              !o && !t && !n && "rounded-r-md"
            ),
            children: e.content
          }
        )
      ]
    }
  );
}
function Wo({
  messages: e
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      ...x("chat/user_msg_group/root"),
      className: p("group", "flex flex-col gap-1 justify-end items-end"),
      children: [
        e.map((o, t, n) => /* @__PURE__ */ r(
          Ho,
          {
            message: o,
            isFirstInGroup: t === 0,
            isLastInGroup: t === n.length - 1,
            isAloneInGroup: n.length === 1
          },
          o.id
        )),
        /* @__PURE__ */ r(or, { messages: e, containerClassName: "ms-auto" })
      ]
    }
  );
}
function Lo(e) {
  const o = [];
  let t = null;
  return e.forEach((n) => {
    var s, i, a, l, c, m;
    // Start a new group if the type changes
    (((s = t == null ? void 0 : t[0]) == null ? void 0 : s.type) !== n.type || // Start a new group if the agent changes
    ((i = t[0]) == null ? void 0 : i.type) === "AGENT" && n.type === "AGENT" && (((a = n.agent) == null ? void 0 : a.id) !== ((l = t[0].agent) == null ? void 0 : l.id) || ((c = n.agent) == null ? void 0 : c.name) !== ((m = t[0].agent) == null ? void 0 : m.name))) && (t = [], o.push(t)), t.push(n);
  }), o;
}
function $o(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "USER";
}
function Bo(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "AI";
}
function Uo(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "AGENT";
}
function Yo() {
  const {
    messagesState: { messages: e }
  } = O(), {
    advancedInitialMessages: o = [],
    initialQuestionsPosition: t,
    initialQuestions: n,
    bot: s
  } = C();
  return /* @__PURE__ */ r(J, { children: e.length === 0 && o.length > 0 && /* @__PURE__ */ r(
    pe,
    {
      messages: o.map(
        ({ message: i }, a) => ({
          component: "bot_message",
          data: { message: i },
          id: `${a}-${i}`,
          type: "AI",
          timestamp: null
        })
      ),
      suggestedReplies: e.length === 0 && t === "below-initial-messages" ? n : void 0,
      agent: s ? { ...s, isAi: !0, id: null } : void 0
    }
  ) });
}
function Xo() {
  const {
    messagesState: { messages: e }
  } = O(), { chatBannerItems: o } = C();
  return !(o != null && o.length) || e.length > 0 && o.every((t) => !t.persistent) ? null : /* @__PURE__ */ r("div", { className: "w-full text-center text-xs", children: o.map(
    ({ message: t, persistent: n }, s) => e.length > 0 && !n ? null : /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(Me, { children: t }) }, `${t}-${s}`)
  ) });
}
const qo = 10 * 1024, _t = /* @__PURE__ */ new Map();
function Vo(e) {
  const o = _t.get(e);
  if (o !== void 0) return o;
  const t = Go(e);
  return _t.set(e, t), t;
}
function Go(e) {
  const o = e.trim();
  if (!o || o.length > qo || typeof DOMParser > "u") return null;
  const t = new DOMParser().parseFromString(o, "image/svg+xml"), n = t.documentElement;
  return n.localName !== "svg" || n.namespaceURI !== "http://www.w3.org/2000/svg" || t.getElementsByTagName("parsererror").length > 0 ? null : `data:image/svg+xml,${encodeURIComponent(o)}`;
}
const Zo = Wt(
  "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        outline: "border text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Ko({ className: e, variant: o, ...t }) {
  return /* @__PURE__ */ r("div", { className: p(Zo({ variant: o }), e), ...t });
}
function nr({
  customStatus: e,
  className: o,
  dotClassName: t
}) {
  const n = e.icon ? Vo(e.icon) : null, s = e.color || "currentColor";
  return n ? /* @__PURE__ */ r(
    "span",
    {
      "aria-hidden": !0,
      className: p("size-3.5 shrink-0", o),
      style: {
        backgroundColor: s,
        // Sized by this element's box, not by the svg's own dimensions
        maskImage: `url("${n}")`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskImage: `url("${n}")`,
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center"
      }
    }
  ) : /* @__PURE__ */ r(
    "span",
    {
      "aria-hidden": !0,
      className: p("size-2 shrink-0 rounded-full", t),
      style: { backgroundColor: s }
    }
  );
}
function sr({
  customStatus: e,
  className: o
}) {
  return /* @__PURE__ */ d(
    Ko,
    {
      variant: "secondary",
      className: p(
        "relative isolate overflow-hidden max-w-full text-primary",
        o
      ),
      title: e.description || void 0,
      style: e.color ? {
        // A stronger shade of the status color: darker on light themes,
        // lighter on dark themes. Unsupported browsers fall back to text-primary.
        color: `color-mix(in srgb, ${e.color} 55%, hsl(var(--opencx-foreground)))`
      } : void 0,
      children: [
        e.color && // A soft uniform wash of the status color over the badge background
        /* @__PURE__ */ r(
          "span",
          {
            "aria-hidden": !0,
            className: "absolute inset-0 -z-10 opacity-20",
            style: { backgroundColor: e.color }
          }
        ),
        /* @__PURE__ */ r(nr, { customStatus: e }),
        /* @__PURE__ */ r("span", { className: "truncate", children: e.name })
      ]
    }
  );
}
function Qo() {
  const {
    sessionState: { session: e }
  } = $(), o = e == null ? void 0 : e.customStatus;
  return /* @__PURE__ */ r(_, { mode: "wait", children: o && /* @__PURE__ */ r(
    y,
    {
      className: "sticky top-2 z-10 self-center max-w-full",
      snapExit: !0,
      children: /* @__PURE__ */ r(
        ge,
        {
          trigger: /* @__PURE__ */ r(N, { variant: "ghost", size: "selfless", className: "rounded-full", children: /* @__PURE__ */ r(sr, { customStatus: o }) }),
          children: /* @__PURE__ */ d(ue, { withClose: !0, children: [
            /* @__PURE__ */ d(Se, { children: [
              /* @__PURE__ */ r(
                nr,
                {
                  customStatus: o,
                  className: "size-8 mx-auto",
                  dotClassName: "size-3 mx-auto"
                }
              ),
              /* @__PURE__ */ r(Ie, { children: o.name })
            ] }),
            o.description && /* @__PURE__ */ r(_e, { children: /* @__PURE__ */ r(Te, { children: o.description }) })
          ] })
        }
      )
    },
    o.id
  ) });
}
function Jo() {
  const {
    messagesState: { messages: e }
  } = O(), o = C(), {
    advancedInitialMessages: t = [],
    initialQuestions: n,
    initialQuestionsPosition: s
  } = o, i = (() => {
    var a;
    return t.length ? [] : e.length ? [] : (a = o.initialMessages) != null && a.length ? o.initialMessages : ["Hello, how can I help you?"];
  })();
  return /* @__PURE__ */ r(J, { children: e.length === 0 && i.length > 0 && /* @__PURE__ */ r(
    pe,
    {
      messages: i.map(
        (a, l) => ({
          component: "bot_message",
          data: { message: a },
          id: `${l}-${a}`,
          type: "AI",
          timestamp: null
        })
      ),
      suggestedReplies: s === "below-initial-messages" ? n : void 0,
      agent: o.bot ? { ...o.bot, isAi: !0, id: null } : void 0
    }
  ) });
}
function en() {
  var t;
  const e = X(), o = (t = e.config.customComponents) == null ? void 0 : t.chatBottomComponents;
  return o ? /* @__PURE__ */ r("div", { children: o.map(({ key: n, component: s }) => /* @__PURE__ */ r(s, { ...e }, n)) }) : null;
}
function tn() {
  const {
    messagesState: { messages: e }
  } = O(), { isAwaitingBotReply: o } = Pt(), { componentStore: t } = A(), { bot: n, humanAgent: s } = C(), i = Dt(
    () => Lo(e),
    [e]
  ), a = t.getComponent(
    "loading"
  ), l = U(null);
  function c() {
    setTimeout(() => {
      const m = l.current;
      m && (m.scrollTop = m.scrollHeight);
    }, 0);
  }
  return se(() => {
    c();
  }, [e]), /* @__PURE__ */ d(
    "div",
    {
      ...x("chat/msgs/root"),
      ref: l,
      className: "max-h-full scroll-smooth relative flex-1 py-2 px-4 flex flex-col gap-2 overflow-auto",
      children: [
        /* @__PURE__ */ r(Qo, {}),
        /* @__PURE__ */ r(Xo, {}),
        /* @__PURE__ */ r(Yo, {}),
        /* @__PURE__ */ r(Jo, {}),
        i.map((m, h) => {
          var u, v, z, M;
          const k = (u = m == null ? void 0 : m[0]) == null ? void 0 : u.type, w = (v = m[0]) == null ? void 0 : v.id;
          if (!k || !w) return null;
          if ($o(m))
            return /* @__PURE__ */ r(Wo, { messages: m }, w);
          if (Bo(m)) {
            const b = h === i.length - 1;
            return o && b ? null : ((z = m[0]) == null || z.agent, /* @__PURE__ */ r(
              pe,
              {
                messages: m,
                agent: n ? { ...n, isAi: !0, id: null } : void 0
              },
              w
            ));
          }
          if (Uo(m)) {
            const b = (M = m[0]) == null ? void 0 : M.agent;
            return /* @__PURE__ */ r(
              pe,
              {
                messages: m,
                agent: b ? {
                  ...b,
                  name: (s == null ? void 0 : s.name) || b.name || "",
                  avatarUrl: (s == null ? void 0 : s.avatarUrl) || b.avatarUrl || null
                } : s ? {
                  isAi: !1,
                  id: null,
                  name: s.name || "",
                  avatarUrl: s.avatarUrl || null
                } : void 0
              },
              w
            );
          }
          return null;
        }),
        o && a && /* @__PURE__ */ r(a, { agent: n }),
        /* @__PURE__ */ r(en, {}),
        /* @__PURE__ */ r(Fo, {})
      ]
    }
  );
}
function rn() {
  const {
    messagesState: { isInitialFetchLoading: e }
  } = O(), {
    sessionState: { session: o }
  } = $(), { isCanvasOpen: t } = So(), { theme: n } = V();
  Pe({
    width: t ? n.screens.chat.withCanvas.width : n.screens.chat.width,
    height: t ? n.screens.chat.withCanvas.height : n.screens.chat.height
  });
  const s = U((o == null ? void 0 : o.id) || "chat").current;
  return /* @__PURE__ */ r(
    "div",
    {
      ...x("chat/root"),
      className: p("flex flex-col overflow-hidden"),
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh"
        // Relative to the iframe
      },
      children: /* @__PURE__ */ d("div", { className: "size-full justify-between flex flex-col", children: [
        /* @__PURE__ */ r(tr, {}),
        /* @__PURE__ */ r(_, { mode: "wait", children: e ? /* @__PURE__ */ r(
          y,
          {
            className: "flex flex-col items-center justify-center w-full flex-1",
            children: /* @__PURE__ */ r(rr, {})
          },
          "loading"
        ) : /* @__PURE__ */ d(
          y,
          {
            className: "flex items-start h-full flex-1 overflow-auto",
            snapExit: !0,
            children: [
              /* @__PURE__ */ d(
                "div",
                {
                  ...x("chat/main/root"),
                  className: p(
                    "flex flex-col h-full overflow-auto transition-all",
                    t ? "w-2/5" : "w-full"
                  ),
                  style: {
                    transitionTimingFunction: n.screens.chat.withCanvas.transitionTimingFunction,
                    transitionDuration: n.screens.chat.withCanvas.transitionDuration
                  },
                  children: [
                    /* @__PURE__ */ r(tn, {}),
                    /* @__PURE__ */ r(Oo, {})
                  ]
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  ...x("chat/canvas/root"),
                  className: p(
                    "h-full overflow-auto transition-all",
                    t ? "w-3/5" : "w-0"
                  ),
                  style: {
                    transitionTimingFunction: n.screens.chat.withCanvas.transitionTimingFunction,
                    transitionDuration: n.screens.chat.withCanvas.transitionDuration
                  },
                  children: /* @__PURE__ */ r(_o, {})
                }
              )
            ]
          },
          s
        ) })
      ] })
    }
  );
}
function on({
  className: e,
  ...o
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      className: p("animate-pulse rounded-md bg-secondary", e),
      ...o
    }
  );
}
function nn({ className: e }) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "26",
      height: "32",
      viewBox: "0 0 26 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: p("text-primary-foreground", e),
      children: /* @__PURE__ */ r(
        "path",
        {
          d: "M1.34103 25.6132H5.44245C5.74203 25.6228 6.02673 25.7462 6.23867 25.9582C6.45062 26.1703 6.5739 26.4551 6.58348 26.7548V30.8584C6.59305 31.1581 6.71634 31.443 6.92828 31.655C7.14023 31.8671 7.42492 31.9904 7.7245 32H18.2894C18.589 31.9904 18.8737 31.8671 19.0856 31.655C19.2976 31.443 19.4209 31.1581 19.4304 30.8584V26.7548C19.4401 26.4545 19.5638 26.1692 19.7765 25.957C19.9892 25.7449 20.2748 25.6219 20.5749 25.6132H24.659C24.9586 25.6036 25.2433 25.4803 25.4552 25.2682C25.6671 25.0562 25.7904 24.7713 25.8 24.4716V7.52839C25.7904 7.22865 25.6671 6.94381 25.4552 6.73176C25.2433 6.5197 24.9586 6.39635 24.659 6.38677H20.561C20.2603 6.37802 19.9742 6.25457 19.7614 6.04169C19.5487 5.82881 19.4253 5.54261 19.4165 5.24168V1.14161C19.4072 0.84419 19.2858 0.561291 19.0768 0.349589C18.8678 0.137887 18.5865 0.0130193 18.2894 0L7.7245 0C7.42492 0.00957792 7.14023 0.132929 6.92828 0.344983C6.71634 0.557036 6.59305 0.841878 6.58348 1.14161V5.24168C6.57477 5.54203 6.45187 5.82773 6.23983 6.04052C6.0278 6.25331 5.74262 6.37715 5.44245 6.38677H1.34103C1.04144 6.39635 0.756749 6.5197 0.544805 6.73176C0.332861 6.94381 0.209574 7.22865 0.200001 7.52839V24.4716C0.209574 24.7713 0.332861 25.0562 0.544805 25.2682C0.756749 25.4803 1.04144 25.6036 1.34103 25.6132ZM6.58348 24.4716V7.52839C6.59305 7.22865 6.71634 6.94381 6.92828 6.73176C7.14023 6.5197 7.42492 6.39635 7.7245 6.38677H18.2894C18.589 6.39635 18.8737 6.5197 19.0856 6.73176C19.2976 6.94381 19.4209 7.22865 19.4304 7.52839V24.4716C19.4209 24.7713 19.2976 25.0562 19.0856 25.2682C18.8737 25.4803 18.589 25.6036 18.2894 25.6132H7.7245C7.42492 25.6036 7.14023 25.4803 6.92828 25.2682C6.71634 25.0562 6.59305 24.7713 6.58348 24.4716Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function ar({ className: e }) {
  const { token: o } = C();
  return /* @__PURE__ */ r(
    "div",
    {
      className: p(
        "flex items-center justify-center gap-2 p-2 pt-0",
        e
      ),
      children: /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ d(
        "a",
        {
          href: `https://open.cx/?ref=${o}`,
          target: "_blank",
          rel: "noreferrer",
          className: p(
            "text-[10px] flex items-center",
            "text-muted-foreground/70 [&_svg]:text-muted-foreground/70",
            "hover:text-primary [&_svg]:hover:text-primary"
          ),
          children: [
            /* @__PURE__ */ r("span", { children: "Powered by" }),
            /* @__PURE__ */ r("span", { children: " " }),
            /* @__PURE__ */ d("span", { className: "flex items-center gap-[1px]", children: [
              /* @__PURE__ */ r("span", { children: /* @__PURE__ */ r(nn, { className: "size-3 inline-block" }) }),
              /* @__PURE__ */ r("span", { className: "font-semibold", children: "open" })
            ] })
          ]
        }
      ) })
    }
  );
}
function sn({ children: e }) {
  return /* @__PURE__ */ r("p", { className: "ps-4 text-xs text-muted-foreground/75 uppercase font-semibold tracking-tight", children: e });
}
function It({
  session: e,
  className: o
}) {
  const { bot: t, humanAgent: n } = C(), { toChatScreen: s } = H(), i = e.assignee.kind === "human" ? (n == null ? void 0 : n.name) || e.assignee.name || "Support Agent" : (t == null ? void 0 : t.name) || "AI Support Agent", a = e.assignee.kind === "human" ? (n == null ? void 0 : n.avatarUrl) || e.assignee.avatarUrl || "" : (t == null ? void 0 : t.avatarUrl) || (t == null ? void 0 : t.avatar) || "";
  return /* @__PURE__ */ d(
    N,
    {
      variant: "ghost",
      size: "lg",
      className: p(
        "rounded-full p-2 pe-4 flex text-start justify-between w-full whitespace-normal",
        o
      ),
      onClick: () => s(e.id),
      children: [
        /* @__PURE__ */ d("div", { className: "flex-1 flex gap-2 items-center", children: [
          /* @__PURE__ */ r(_, { mode: "wait", children: /* @__PURE__ */ r(y, { snapExit: !0, children: /* @__PURE__ */ d(De, { className: "size-10", children: [
            /* @__PURE__ */ r(Ee, { src: a, alt: "Agent Icon" }),
            /* @__PURE__ */ r(Re, { children: /* @__PURE__ */ r(Lr, { className: "size-4" }) })
          ] }) }) }),
          /* @__PURE__ */ d("div", { className: "flex-1", children: [
            /* @__PURE__ */ r(_, { mode: "wait", children: /* @__PURE__ */ r(y, { snapExit: !0, children: i }, i) }),
            /* @__PURE__ */ r(_, { mode: "wait", children: e.lastMessage ? /* @__PURE__ */ r(y, { snapExit: !0, children: /* @__PURE__ */ r(
              Gt,
              {
                remarkPlugins: [Lt],
                rehypePlugins: [$t],
                className: "line-clamp-1 overflow-hidden text-ellipsis text-xs text-muted-foreground",
                children: e.lastMessage
              }
            ) }, e.lastMessage || "content") : /* @__PURE__ */ r(y, { className: "w-1/2", snapExit: !0, children: /* @__PURE__ */ r(on, { className: "h-4 w-full" }) }, "skeleton") }),
            /* @__PURE__ */ r(_, { mode: "wait", children: e.customStatus && /* @__PURE__ */ r(
              y,
              {
                className: "mt-1",
                snapExit: !0,
                children: /* @__PURE__ */ r(sr, { customStatus: e.customStatus })
              },
              e.customStatus.id
            ) })
          ] })
        ] }),
        /* @__PURE__ */ r($r, { className: "size-4 text-muted-foreground shrink-0 rtl:-scale-100" })
      ]
    }
  );
}
function an() {
  const { t: e } = G(), { toChatScreen: o } = H(), {
    sessionsState: { data: t, isInitialFetchLoading: n },
    openSessions: s,
    closedSessions: i,
    canCreateNewSession: a
  } = $();
  return /* @__PURE__ */ r("div", { className: "flex-1 flex flex-col overflow-scroll py-2 px-2", children: /* @__PURE__ */ r(_, { mode: "wait", children: n ? /* @__PURE__ */ r(
    y,
    {
      className: "flex-1 flex items-center justify-center",
      children: /* @__PURE__ */ r(rr, {})
    },
    "loading"
  ) : /* @__PURE__ */ r(
    y,
    {
      className: "flex-1 flex flex-col gap-2 relative",
      children: t.length ? /* @__PURE__ */ d(J, { children: [
        /* @__PURE__ */ d(_, { children: [
          s.length > 0 && /* @__PURE__ */ r(
            y,
            {
              fadeIn: "up",
              delay: 0.2,
              className: "space-y-2",
              snapExit: !0,
              children: s.map((l) => /* @__PURE__ */ r(It, { session: l }, l.id))
            },
            "open-sessions"
          ),
          i.length > 0 && /* @__PURE__ */ d(
            y,
            {
              className: "space-y-2",
              delay: 0.2,
              snapExit: !0,
              children: [
                /* @__PURE__ */ r(sn, { children: e("closed_conversations") }),
                i.map((l) => /* @__PURE__ */ r(
                  It,
                  {
                    session: l,
                    className: "opacity-50 hover:opacity-100"
                  },
                  l.id
                ))
              ]
            },
            "closed-sessions"
          )
        ] }),
        a && /* @__PURE__ */ r("div", { className: "mt-auto w-full rounded-3xl sticky bottom-0 outline outline-8 outline-background bg-background", children: /* @__PURE__ */ gt(
          N,
          {
            ...x("sessions/new_conversation_btn"),
            size: "lg",
            key: "new-session",
            className: "w-full",
            onClick: () => o()
          },
          e("new_conversation")
        ) })
      ] }) : /* @__PURE__ */ d("div", { className: "flex-1 flex flex-col gap-2 items-center", children: [
        /* @__PURE__ */ r("div", { className: "flex-1 flex items-center justify-center", children: /* @__PURE__ */ r("p", { className: "text-muted-foreground", children: e("no_conversations_yet") }) }),
        /* @__PURE__ */ gt(
          N,
          {
            ...x("sessions/new_conversation_btn"),
            size: "lg",
            key: "new-session",
            className: "w-full",
            onClick: () => o()
          },
          e("new_conversation")
        )
      ] })
    },
    "sessions"
  ) }) });
}
function ln() {
  const { theme: e } = V();
  return Pe({
    width: e.screens.sessions.width,
    height: e.screens.sessions.height
  }), /* @__PURE__ */ r(
    "div",
    {
      ...x("sessions/root"),
      className: p("flex flex-col overflow-hidden bg-background"),
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh"
        // Relative to the iframe
      },
      children: /* @__PURE__ */ d("div", { className: "size-full flex flex-col", children: [
        /* @__PURE__ */ r(tr, {}),
        /* @__PURE__ */ r(an, {}),
        /* @__PURE__ */ r(ar, {})
      ] })
    }
  );
}
const de = ee.forwardRef(
  ({ className: e, type: o, ...t }, n) => {
    const { isSmallScreen: s } = B();
    return /* @__PURE__ */ r(
      "input",
      {
        ref: n,
        type: o,
        className: p(
          // 16px on mobiles prevents auto-zoom on the input when focused
          s ? "text-[16px]" : "text-sm",
          "flex w-full rounded-xl p-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-primary-foreground placeholder:text-muted-foreground/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition",
          "rounded-2xl px-4",
          "border shadow-sm",
          e
        ),
        ...t
      }
    );
  }
);
de.displayName = "Input";
function cn() {
  const { contentIframeRef: e } = A(), { inline: o } = C(), t = U(null);
  return se(() => {
    const n = e == null ? void 0 : e.current;
    if (n && t.current) {
      const s = t.current;
      let i;
      const a = new ResizeObserver(() => {
        i = requestAnimationFrame(() => {
          const l = s.offsetHeight;
          n.style.setProperty(
            "--opencx-widget-height",
            o ? "100%" : `${l.toFixed(1)}px`
          );
        });
      });
      return a.observe(s), () => {
        cancelAnimationFrame(i), a.unobserve(s);
      };
    }
  }, [e, o]), { observedElementRef: t };
}
const dn = fe.object({
  name: fe.string().min(2),
  email: fe.string().email()
});
function pn() {
  var b, S, I, E, f, D, j, R;
  const {
    widgetCtx: { org: e }
  } = A(), { setIsOpen: o } = K(), { createUnverifiedContact: t } = jt(), { isSmallScreen: n } = B(), s = C(), { theme: i } = V(), { t: a } = G(), { observedElementRef: l } = cn();
  Pe({
    height: void 0,
    width: i.screens.welcome.width
  });
  const [c, m] = P(((b = s.prefillUserData) == null ? void 0 : b.name) || ""), [h, k] = P(((S = s.prefillUserData) == null ? void 0 : S.email) || ""), w = (s.extraDataCollectionFields || []).filter(
    (g) => g !== "name" && g !== "email" && !!g
  ), [u, v] = P({}), [z, M] = Qr(
    async (g) => {
      g.preventDefault();
      const T = dn.safeParse({ name: c, email: h });
      T.success && await t(
        {
          email: T.data.email,
          non_verified_name: T.data.name
        },
        // Only pass extra data if there is any
        Object.values(u).filter(Boolean).length ? u : void 0
      );
    },
    [c, h, u]
  );
  return /* @__PURE__ */ r(
    "div",
    {
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        minHeight: i.screens.welcome.minHeight,
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh",
        // Relative to the iframe
        overflowY: "auto"
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: l,
          className: p(
            "flex flex-col",
            n && "h-full",
            "bg-[radial-gradient(ellipse_at_top_left,hsl(var(--opencx-primary)),transparent),radial-gradient(ellipse_at_top_right,hsl(var(--opencx-primary)),transparent)]"
          ),
          children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: p(
                  "flex-1 flex flex-col px-4 py-12 text-start space-y-4 relative z-10",
                  "text-primary-foreground"
                ),
                children: [
                  n && /* @__PURE__ */ r(y, { className: "absolute top-6 end-6", children: /* @__PURE__ */ r(N, { size: "selfless", onClick: () => o(!1), children: /* @__PURE__ */ r(Ne, { className: "size-4" }) }) }),
                  /* @__PURE__ */ r("div", { className: "flex items-center justify-between w-full mb-2", children: (I = s.assets) != null && I.organizationLogo ? /* @__PURE__ */ r(
                    "img",
                    {
                      src: (E = s.assets) == null ? void 0 : E.organizationLogo,
                      alt: "Company Logo",
                      className: "h-8 w-auto object-contain"
                    }
                  ) : /* @__PURE__ */ r("h2", { className: "font-bold text-sm", children: e.name }) }),
                  /* @__PURE__ */ d("div", { className: "space-y-2", children: [
                    /* @__PURE__ */ r("h1", { className: "text-[1.75rem] font-semibold tracking-tight leading-none", children: ((D = (f = s.textContent) == null ? void 0 : f.welcomeScreen) == null ? void 0 : D.title) || a("welcome_screen_title") }),
                    /* @__PURE__ */ r("p", { className: "text-sm", children: ((R = (j = s.textContent) == null ? void 0 : j.welcomeScreen) == null ? void 0 : R.description) || a("welcome_screen_description") })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ d(
              "div",
              {
                className: p(
                  "z-10 m-2 px-2 pt-2 bp-0 space-y-2",
                  "bg-[white]",
                  "border shadow",
                  "rounded-3xl"
                ),
                children: [
                  /* @__PURE__ */ d("form", { onSubmit: M, className: "space-y-2", children: [
                    /* @__PURE__ */ r(
                      de,
                      {
                        value: c,
                        onChange: (g) => m(g.target.value),
                        required: !0,
                        placeholder: a("your_name_placeholder"),
                        name: "name"
                      }
                    ),
                    /* @__PURE__ */ r(
                      de,
                      {
                        required: !0,
                        value: h,
                        onChange: (g) => k(g.target.value),
                        type: "email",
                        placeholder: a("your_email_placeholder"),
                        name: "email"
                      }
                    ),
                    w.map((g) => /* @__PURE__ */ r(
                      de,
                      {
                        value: u[g],
                        onChange: (T) => v((ie) => ({
                          ...ie,
                          [g]: T.target.value
                        })),
                        placeholder: `${g} (${a("optional")})`
                      },
                      g
                    )),
                    /* @__PURE__ */ d(
                      N,
                      {
                        disabled: z.loading,
                        className: "w-full",
                        size: "lg",
                        children: [
                          z.loading ? a("start_chat_button_loading") : a("start_chat_button"),
                          /* @__PURE__ */ r(Br, { className: "size-4 rtl:-scale-100" })
                        ]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ r(ar, {})
                ]
              }
            )
          ]
        }
      )
    }
  );
}
function ir() {
  const {
    routerState: { screen: e }
  } = H();
  return /* @__PURE__ */ r("div", { className: "relative bg-background size-full", children: /* @__PURE__ */ r(_, { mode: "wait", children: (() => {
    switch (e) {
      case "welcome":
        return /* @__PURE__ */ r(
          y,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(pn, {})
          },
          e
        );
      case "sessions":
        return /* @__PURE__ */ r(
          y,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(ln, {})
          },
          e
        );
      case "chat":
        return /* @__PURE__ */ r(
          y,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(rn, {})
          },
          e
        );
      default:
        return F(e, ir.name), null;
    }
  })() }) });
}
const mn = "4.0.63", hn = `<!DOCTYPE html>
<html>
<head>
<style>
${Zt}
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
}
</style>
<meta name="viewport" content="width=device-width, initial-scale=1, interactive-widget=resizes-content">
</head>
<body>
</body>
</html>`;
function lr() {
  const { isOpen: e } = K(), { contentIframeRef: o } = A(), { cssOverrides: t, inline: n } = C(), { theme: s, cssVars: i, computed: a } = V(), { dir: l } = G();
  return /* @__PURE__ */ r(
    re.div,
    {
      animate: e ? "visible" : "hidden",
      initial: "hidden",
      variants: {
        hidden: {
          opacity: 0,
          y: 8,
          transitionEnd: { display: "none" },
          transition: { duration: 0.15 }
        },
        visible: {
          opacity: 1,
          y: 0,
          display: "block",
          height: n ? "100%" : void 0
        }
      },
      children: /* @__PURE__ */ d(
        Bt,
        {
          ref: o,
          initialContent: hn,
          allowFullScreen: !0,
          title: "OpenCX Live Chat",
          style: {
            // @ts-expect-error this is a valid css variable
            "--opencx-widget-width": a.minWidth,
            "--opencx-widget-height": a.minHeight,
            minWidth: a.minWidth,
            width: "var(--opencx-widget-width)",
            maxWidth: a.maxWidth,
            // Relative to the viewport
            minHeight: a.minHeight,
            height: "var(--opencx-widget-height)",
            maxHeight: a.maxHeight,
            // Relative to the viewport
            overflow: "hidden",
            /** outline is better than border because of box sizing; the outline wouldn't affect the content inside... the border will mess up how the children's border radius sits with the parent */
            outline: s.widgetContentContainer.outline,
            outlineColor: s.widgetContentContainer.outlineColor,
            borderRadius: s.widgetContentContainer.borderRadius,
            boxShadow: s.widgetContentContainer.boxShadow,
            transitionProperty: s.widgetContentContainer.transitionProperty,
            transitionTimingFunction: s.widgetContentContainer.transitionTimingFunction,
            transitionDuration: s.widgetContentContainer.transitionDuration,
            // reset iframe defaults
            boxSizing: "border-box",
            borderWidth: "0px"
          },
          children: [
            t && /* @__PURE__ */ r("style", { children: t }),
            /* @__PURE__ */ r(
              "div",
              {
                style: {
                  ...i,
                  zIndex: s.widgetContentContainer.zIndex
                },
                "data-version": mn,
                className: p(
                  "antialiased font-sans size-full overflow-hidden relative text-secondary-foreground isolate"
                ),
                dir: l,
                children: /* @__PURE__ */ r(
                  uo,
                  {
                    delayDuration: 200,
                    disableHoverableContent: !0,
                    children: /* @__PURE__ */ r(ao, { children: /* @__PURE__ */ r(ir, {}) })
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
function un() {
  const { theme: e, triggerSide: o } = V(), { dir: t } = ze(), n = (t === "rtl" ? o === "left" : o === "right") ? "end" : "start";
  return /* @__PURE__ */ r(
    me.Content,
    {
      onInteractOutside: (s) => s.preventDefault(),
      forceMount: !0,
      style: {
        zIndex: e.widgetContentContainer.zIndex,
        fontSize: "16px"
      },
      side: "top",
      align: n,
      "aria-modal": "false",
      "aria-label": "Support chat",
      sideOffset: e.widgetContentContainer.offset.side,
      alignOffset: e.widgetContentContainer.offset.align,
      avoidCollisions: !1,
      children: /* @__PURE__ */ r(lr, {})
    }
  );
}
function gn({
  className: e,
  style: o
}) {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "32",
      height: "30",
      viewBox: "0 0 32 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: p("text-primary-foreground", e),
      style: o,
      children: [
        /* @__PURE__ */ r(
          "path",
          {
            d: "M0 6.94263C0 3.62892 2.68629 0.942627 6 0.942627H26C29.3137 0.942627 32 3.62892 32 6.94263V17.9426C32 21.2563 29.3137 23.9426 26 23.9426H6C2.68629 23.9426 0 21.2563 0 17.9426V6.94263Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.9945 23.8935L26.237 23.8934C26.1982 24.3557 26.1712 25.2778 26.1704 26.2318C26.1688 28.2839 26.1376 28.7041 25.974 28.868C25.583 29.2598 25.2686 29.0967 24.0616 27.8754C23.4162 27.2222 22.1141 25.9522 21.1682 25.0531L19.9945 23.8935Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
const wn = `<!DOCTYPE html>
<html>
<head>
<style>
${Zt}
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
}
</style>
</head>
<body>
</body>
</html>`;
function fn() {
  var m, h, k;
  const { isOpen: e, setIsOpen: o } = K(), { cssOverrides: t, assets: n, customComponents: s, accessibility: i } = C(), { theme: a, cssVars: l } = V(), c = ((m = i == null ? void 0 : i.widgetTriggerButton) == null ? void 0 : m.label) ?? "Chat with us";
  return s != null && s.widgetTrigger ? s.widgetTrigger({
    react: L,
    isOpen: e,
    setIsOpen: (w) => o(w)
  }) : /* @__PURE__ */ d(
    Bt,
    {
      initialContent: wn,
      title: "OpenCX Live Chat Trigger",
      style: {
        height: `calc(${a.widgetTrigger.size.button}px + ${Q.x * 2}px)`,
        width: `calc(${a.widgetTrigger.size.button}px + ${Q.y * 2}px)`,
        fontSize: "16px",
        position: "fixed",
        zIndex: a.widgetTrigger.zIndex,
        right: a.widgetTrigger.offset.right,
        bottom: a.widgetTrigger.offset.bottom,
        left: a.widgetTrigger.offset.left,
        // reset iframe defaults
        boxSizing: "border-box",
        borderWidth: "0px",
        // A quick fix for the white square background of the iframe when the hosting website switches to dark mode
        borderRadius: "100%"
      },
      children: [
        t && /* @__PURE__ */ r("style", { children: t }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              ...l,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ r(
              me.PopoverTrigger,
              {
                "aria-label": c,
                title: c,
                className: p(
                  "font-sans flex items-center justify-center rounded-full"
                ),
                style: {
                  height: a.widgetTrigger.size.button,
                  width: a.widgetTrigger.size.button
                },
                children: /* @__PURE__ */ r(Y, { children: /* @__PURE__ */ r(
                  "div",
                  {
                    ...x("trigger/btn"),
                    className: p(
                      "relative size-full rounded-full",
                      "flex items-center justify-center",
                      "overflow-hidden",
                      "transition-all",
                      "bg-primary",
                      "text-primary-foreground"
                    ),
                    children: /* @__PURE__ */ r(_, { mode: "wait", children: e ? /* @__PURE__ */ r(
                      y,
                      {
                        snapExit: !0,
                        fadeIn: "up",
                        overrides: {
                          initial: { rotate: 45 },
                          animate: { rotate: 0 }
                        },
                        children: (h = n == null ? void 0 : n.widgetTrigger) != null && h.closeIcon ? /* @__PURE__ */ r(
                          "img",
                          {
                            src: n.widgetTrigger.closeIcon,
                            alt: "Widget trigger close icon",
                            style: {
                              width: a.widgetTrigger.size.icon,
                              height: a.widgetTrigger.size.icon
                            }
                          }
                        ) : /* @__PURE__ */ r(
                          Ur,
                          {
                            style: {
                              width: a.widgetTrigger.size.icon,
                              height: a.widgetTrigger.size.icon
                            }
                          }
                        )
                      },
                      "x-icon"
                    ) : /* @__PURE__ */ r(
                      y,
                      {
                        snapExit: !0,
                        overrides: {
                          initial: { rotate: 45 },
                          animate: { rotate: 0 }
                        },
                        children: (k = n == null ? void 0 : n.widgetTrigger) != null && k.openIcon ? /* @__PURE__ */ r(
                          "img",
                          {
                            src: n.widgetTrigger.openIcon,
                            alt: "Widget trigger open icon",
                            style: {
                              width: a.widgetTrigger.size.icon,
                              height: a.widgetTrigger.size.icon
                            }
                          }
                        ) : /* @__PURE__ */ r(
                          gn,
                          {
                            style: {
                              width: a.widgetTrigger.size.icon,
                              height: a.widgetTrigger.size.icon
                            },
                            className: "mt-0.5 opacity-95"
                          }
                        )
                      },
                      "message-icon"
                    ) })
                  }
                ) })
              }
            )
          }
        )
      ]
    }
  );
}
function xn() {
  const { triggerSide: e } = V();
  return /* @__PURE__ */ r(
    me.Anchor,
    {
      style: {
        position: "fixed",
        bottom: 0,
        right: e === "right" ? 0 : void 0,
        left: e === "left" ? 0 : void 0
      }
    }
  );
}
function vn({
  widgetRef: e
}) {
  const { widgetCtx: o } = A(), { contactState: t } = jt(), { setIsOpen: n, isOpen: s } = K(), {
    toChatScreen: i,
    routerState: { screen: a }
  } = H(), { sendMessage: l } = O();
  return L.useImperativeHandle(
    e,
    () => ({
      newChat: async (c) => {
        var m;
        if (!((m = t.contact) != null && m.token)) {
          console.warn("Cannot start a new chat: contact not yet initialized.");
          return;
        }
        console.log({ isOpen: s }), s || n(!0), a === "chat" && o.resetChat(), i(), c != null && c.message && l({ content: c.message });
      }
    }),
    [
      o,
      t,
      n,
      s,
      a,
      i,
      l
    ]
  ), null;
}
function bn() {
  const { isOpen: e, setIsOpen: o } = K();
  return /* @__PURE__ */ d(me.Root, { open: e, onOpenChange: o, children: [
    /* @__PURE__ */ r(xn, {}),
    /* @__PURE__ */ r(fn, {}),
    /* @__PURE__ */ r(un, {})
  ] });
}
const yn = [
  {
    key: "loading",
    component: ho
  },
  {
    key: "fallback",
    component: mo
  },
  {
    key: "bot_message",
    component: be
  },
  {
    key: "agent_message",
    component: be
  }
], kn = {
  get: async (e) => localStorage.getItem(e),
  set: async (e, o) => {
    localStorage.setItem(e, o);
  },
  remove: async (e) => {
    localStorage.removeItem(e);
  }
}, Cn = L.forwardRef(function({ options: o, components: t = [], loadingComponent: n }, s) {
  return /* @__PURE__ */ r(
    hr,
    {
      components: [...yn, ...t],
      options: o,
      storage: kn,
      loadingComponent: n,
      children: /* @__PURE__ */ d(ur, { children: [
        /* @__PURE__ */ r(vn, { widgetRef: s }),
        o.inline ? /* @__PURE__ */ r(lr, {}) : /* @__PURE__ */ r(bn, {})
      ] })
    }
  );
});
Cn.displayName = "Widget";
export {
  Cn as Widget
};
//# sourceMappingURL=index.js.map
